import { useState, useRef, useCallback, useEffect } from "react";
import { supabase } from "./supabaseClient";

// ── AUTH SCREEN ───────────────────────────────────────────────────────────────
function AuthScreen({ onAuth, inviteToken }) {
  const [tab,      setTab]      = useState(inviteToken ? "invite" : "login");
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [name,     setName]     = useState("");
  const [company,  setCompany]  = useState("");
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState("");
  const [success,  setSuccess]  = useState("");

  const inp = { width:"100%", background:"#2a2e38", border:"1px solid #353a47", color:"#f1f5f9", borderRadius:10, padding:"13px 14px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:14, outline:"none", marginBottom:12 };

  const handleLogin = async () => {
    if (!email || !password) { setError("Please fill in all fields"); return; }
    setLoading(true); setError("");
    const { error: err } = await supabase.auth.signInWithPassword({ email, password });
    if (err) { setError(err.message); setLoading(false); return; }
    onAuth();
  };

  const handleSignup = async () => {
    if (!email || !password || !name || !company) { setError("Please fill in all fields"); return; }
    if (password.length < 6) { setError("Password must be at least 6 characters"); return; }
    setLoading(true); setError("");
    const { error: err } = await supabase.auth.signUp({ email, password, options: { data: { full_name: name, company_name: company } } });
    if (err) { setError(err.message); setLoading(false); return; }
    setSuccess("Account created! Check your email to confirm, then log in.");
    setTab("login"); setLoading(false);
  };

  const handleInviteSignup = async () => {
    if (!email || !password || !name) { setError("Please fill in all fields"); return; }
    if (password.length < 6) { setError("Password must be at least 6 characters"); return; }
    setLoading(true); setError("");
    const { data, error: err } = await supabase.auth.signUp({ email, password, options: { data: { full_name: name, invite_token: inviteToken } } });
    if (err) { setError(err.message); setLoading(false); return; }
    if (data?.user) {
      const { data: result } = await supabase.rpc("accept_invite", { invite_token: inviteToken, user_id: data.user.id, user_name: name });
      if (result?.error) { setError(result.error); setLoading(false); return; }
    }
    setSuccess("Account created! Check your email to confirm, then log in.");
    setTab("login"); setLoading(false);
  };

  const handleReset = async () => {
    if (!email) { setError("Enter your email first"); return; }
    setLoading(true); setError("");
    const { error: err } = await supabase.auth.resetPasswordForEmail(email, { redirectTo: "https://beamshots.io" });
    if (err) { setError(err.message); } else { setSuccess("Password reset email sent!"); }
    setLoading(false);
  };

  const btnStyle = { width:"100%", background:"linear-gradient(135deg,#f97316,#c2410c)", color:"#fff", border:"none", borderRadius:10, padding:"14px", fontFamily:"'Bebas Neue',sans-serif", fontSize:18, letterSpacing:2, cursor:"pointer", boxShadow:"0 4px 20px #f9731640" };
  const labelStyle = { color:"#94a3b8", fontSize:11, letterSpacing:2, display:"block", marginBottom:6 };

  return (
    <div style={{ minHeight:"100vh", background:"#181a1f", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"24px", fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap'); *{box-sizing:border-box;margin:0;padding:0;} input::placeholder{color:#475569;}`}</style>
      <img src="/logo192.png" alt="BeamShots" style={{ height:90, objectFit:"contain", marginBottom:16 }} />
      <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:28, color:"#f1f5f9", letterSpacing:4, marginBottom:4 }}>BEAM SHOTS</div>
      <div style={{ color:"#f97316", fontSize:11, letterSpacing:3, fontWeight:700, marginBottom:32 }}>JOBSITE PHOTOS</div>
      <div style={{ width:"100%", maxWidth:400, background:"#21242c", borderRadius:16, border:"1px solid #353a47", padding:"28px 24px" }}>
        {inviteToken ? (
          <div style={{ textAlign:"center", marginBottom:20 }}>
            <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:20, color:"#f97316", letterSpacing:2, marginBottom:6 }}>YOU'VE BEEN INVITED!</div>
            <div style={{ color:"#94a3b8", fontSize:13 }}>Create your account to join the crew</div>
          </div>
        ) : (
          <div style={{ display:"flex", marginBottom:24, borderBottom:"1px solid #353a47" }}>
            {[["login","Log In"],["signup","Sign Up"]].map(([id,label])=>(
              <button key={id} onClick={()=>{ setTab(id); setError(""); setSuccess(""); }} style={{ flex:1, background:"none", border:"none", borderBottom:"2px solid " + (tab===id?"#f97316":"transparent"), color:tab===id?"#f97316":"#94a3b8", padding:"10px 0", fontFamily:"'Bebas Neue',sans-serif", fontSize:15, letterSpacing:2, cursor:"pointer" }}>{label}</button>
            ))}
          </div>
        )}
        {error   && <div style={{ background:"#2a0a0a", border:"1px solid #ef444460", color:"#ef4444", fontSize:13, padding:"10px 14px", borderRadius:8, marginBottom:14 }}>⚠️ {error}</div>}
        {success && <div style={{ background:"#0a2a0a", border:"1px solid #4ade8060", color:"#4ade80", fontSize:13, padding:"10px 14px", borderRadius:8, marginBottom:14 }}>✓ {success}</div>}
        {tab==="login" && (<>
          <label style={labelStyle}>EMAIL</label>
          <input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@example.com" style={inp} />
          <label style={labelStyle}>PASSWORD</label>
          <input type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="••••••••" style={{ ...inp, marginBottom:6 }} onKeyDown={e=>e.key==="Enter"&&handleLogin()} />
          <button onClick={handleReset} style={{ background:"none", border:"none", color:"#94a3b8", fontSize:12, cursor:"pointer", marginBottom:20, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>Forgot password?</button>
          <button onClick={handleLogin} disabled={loading} style={{ ...btnStyle, opacity:loading?0.7:1 }}>{loading?"LOGGING IN...":"LOG IN"}</button>
        </>)}
        {tab==="signup" && (<>
          <label style={labelStyle}>YOUR NAME</label>
          <input value={name} onChange={e=>setName(e.target.value)} placeholder="Barry Smith" style={inp} />
          <label style={labelStyle}>COMPANY NAME</label>
          <input value={company} onChange={e=>setCompany(e.target.value)} placeholder="Smith Construction LLC" style={inp} />
          <label style={labelStyle}>EMAIL</label>
          <input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@example.com" style={inp} />
          <label style={labelStyle}>PASSWORD</label>
          <input type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="Min. 6 characters" style={{ ...inp, marginBottom:20 }} onKeyDown={e=>e.key==="Enter"&&handleSignup()} />
          <button onClick={handleSignup} disabled={loading} style={{ ...btnStyle, opacity:loading?0.7:1 }}>{loading?"CREATING ACCOUNT...":"CREATE ACCOUNT"}</button>
        </>)}
        {tab==="invite" && (<>
          <label style={labelStyle}>YOUR NAME</label>
          <input value={name} onChange={e=>setName(e.target.value)} placeholder="Your full name" style={inp} />
          <label style={labelStyle}>EMAIL</label>
          <input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@example.com" style={inp} />
          <label style={labelStyle}>CREATE PASSWORD</label>
          <input type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="Min. 6 characters" style={{ ...inp, marginBottom:20 }} onKeyDown={e=>e.key==="Enter"&&handleInviteSignup()} />
          <button onClick={handleInviteSignup} disabled={loading} style={{ ...btnStyle, opacity:loading?0.7:1 }}>{loading?"JOINING...":"JOIN THE CREW 👷"}</button>
        </>)}
      </div>
      <div style={{ color:"#475569", fontSize:12, marginTop:20, textAlign:"center" }}>Your data is private and secure.</div>
    </div>
  );
}


const CATEGORIES = ["General","Framing","Electrical","Plumbing","Roofing","Decking","Concrete","Insulation","Finish Work"];
const CAT_ICONS  = { General:"📷", Framing:"🪵", Electrical:"⚡", Plumbing:"🔧", Roofing:"🏠", Decking:"🪚", Concrete:"🧱", Insulation:"🧊", "Finish Work":"🎨" };
const CAT_COLOR  = { General:"#94a3b8", Framing:"#c87941", Electrical:"#f0c040", Plumbing:"#4db8f0", Roofing:"#a06bdb", Decking:"#8bc34a", Concrete:"#9e9e9e", Insulation:"#80d8e8", "Finish Work":"#f48fb1" };

// ── THEME — dynamic via CSS custom properties ─────────────────────────────────
const BG   = "#181a1f";
const BG2  = "#21242c";
const BG3  = "#2a2e38";
const BG4  = "#353a47";
const OR   = "var(--brand-or)";
const ORL  = "var(--brand-orl)";
const ORD  = "var(--brand-ord)";
const TEXT = "#f1f5f9";
const MUTED= "#94a3b8";
const DIM  = "#475569";

const STATUS_COLORS = {
  active:    { bg:"#142010", border:"#276627", text:"#4ade80", dot:"#4ade80" },
  completed: { bg:"#0f1e35", border:"#1d4ed8", text:"#60a5fa", dot:"#60a5fa" },
  "on hold": { bg:"#2a1505", border:"#c2410c", text:"#fb923c", dot:"#fb923c" },
};

const LOGO_URL     = "/logo192.png";
const DEFAULT_TAGLINE = "Every deck pic and penetration on record. Your ass, covered.";
const LOGO_HEIGHTS = { small: 28, medium: 42, large: 58 };
const CANCEL_REASONS = [
  "Too expensive",
  "Not using it enough",
  "Missing a feature I need",
  "Switched to a different app",
  "Going out of business / no longer contracting",
  "Other",
];

const ATHENA_NAME = "Athena";
const ATHENA_ICON = "/athena.png";

// ── COLOR UTILITIES ───────────────────────────────────────────────────────────
function hexToRgb(hex) {
  const h = (hex || "#f97316").replace("#", "");
  if (h.length !== 6) return "249,115,22";
  const n = parseInt(h, 16);
  return (n >> 16) + "," + ((n >> 8) & 255) + "," + (n & 255);
}

function hexAdjust(hex, amt) {
  const h = (hex || "#f97316").replace("#", "");
  if (h.length !== 6) return hex;
  const n = parseInt(h, 16);
  const clamp = v => Math.min(255, Math.max(0, v));
  const r = clamp((n >> 16) + amt).toString(16).padStart(2, "0");
  const g = clamp(((n >> 8) & 255) + amt).toString(16).padStart(2, "0");
  const b = clamp((n & 255) + amt).toString(16).padStart(2, "0");
  return "#" + r + g + b;
}

function extractColors(imgEl) {
  const canvas = document.createElement("canvas");
  canvas.width = 60; canvas.height = 60;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(imgEl, 0, 0, 60, 60);
  const { data } = ctx.getImageData(0, 0, 60, 60);
  const buckets = {};
  for (let i = 0; i < data.length; i += 4) {
    const r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];
    if (a < 128) continue;
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    if (brightness < 40 || brightness > 215) continue;
    const qr = Math.round(r / 32) * 32;
    const qg = Math.round(g / 32) * 32;
    const qb = Math.round(b / 32) * 32;
    const key = qr + "," + qg + "," + qb;
    buckets[key] = (buckets[key] || 0) + 1;
  }
  const sorted = Object.entries(buckets).sort((a, b) => b[1] - a[1]);
  if (!sorted.length) return { primary: "#f97316", secondary: "#f59e0b" };
  const [r1, g1, b1] = sorted[0][0].split(",").map(Number);
  const primary = "#" + [r1, g1, b1].map(v => v.toString(16).padStart(2, "0")).join("");
  let secondary = "#f59e0b";
  for (const [key] of sorted.slice(1)) {
    const [r2, g2, b2] = key.split(",").map(Number);
    if (Math.abs(r1 - r2) + Math.abs(g1 - g2) + Math.abs(b1 - b2) > 80) {
      secondary = "#" + [r2, g2, b2].map(v => v.toString(16).padStart(2, "0")).join("");
      break;
    }
  }
  return { primary, secondary };
}

// ── BILLING ───────────────────────────────────────────────────────────────────
function getBillingStatus(companies) {
  const plan = companies?.plan || "trial";
  if (plan === "grandfathered" || plan === "starter" || plan === "pro" || plan === "business") {
    return { access: "full", plan };
  }
  const trialEndsAt = companies?.trial_ends_at;
  if (!trialEndsAt) return { access: "setup_required", plan: "trial", daysLeft: 0 };
  const msLeft = new Date(trialEndsAt).getTime() - Date.now();
  const daysLeft = Math.ceil(msLeft / (1000 * 60 * 60 * 24));
  return daysLeft > 0
    ? { access: "trial", plan: "trial", daysLeft }
    : { access: "expired", plan: "trial", daysLeft: 0 };
}

function fmtD(ts) { return new Date(ts).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}); }
function daysSince(ts) { return Math.floor((Date.now()-new Date(ts).getTime())/(1000*60*60*24)); }

function buildJobAnalytics(job, photos, staleThreshold, staleAlertsEnabled, allCategories) {
  const threshold = staleThreshold !== undefined ? staleThreshold : 2;
  const alertsOn  = staleAlertsEnabled !== undefined ? staleAlertsEnabled : true;
  const pics = photos.filter(p => p.job_id === job.id);
  const lastPhotoTs = pics.length ? Math.max(...pics.map(p=>new Date(p.created_at).getTime())) : null;
  const staleDays   = lastPhotoTs ? daysSince(new Date(lastPhotoTs).toISOString()) : daysSince(job.created_at);
  const momentum    = (alertsOn && staleDays >= threshold) ? "stale" : "active";
  const elapsedDays = daysSince(job.created_at);
  const pctTime     = job.estimated_days ? Math.min(100, Math.round(elapsedDays/job.estimated_days*100)) : null;
  const byCat = {};
  (allCategories||CATEGORIES).forEach(c => {
    const cp = pics.filter(p=>(p.category||"General")===c).sort((a,b)=>new Date(a.created_at)-new Date(b.created_at));
    if (!cp.length) return;
    byCat[c] = { count:cp.length, spanDays:cp.length>1?Math.max(1,Math.round((new Date(cp[cp.length-1].created_at)-new Date(cp[0].created_at))/86400000)):1 };
  });
  const byDay = {};
  pics.forEach(p => {
    const d = new Date(p.created_at);
    const k = d.getFullYear() + "-" + String(d.getMonth()+1).padStart(2,"0") + "-" + String(d.getDate()).padStart(2,"0");
    byDay[k] = (byDay[k]||0)+1;
  });
  return { lastPhotoTs, staleDays, momentum, elapsedDays, pctTime, byCat, byDay, totalPhotos:pics.length };
}

// ── UI PRIMITIVES ─────────────────────────────────────────────────────────────
function StatusBadge({ status }) {
  const c = STATUS_COLORS[status]||STATUS_COLORS["on hold"];
  return <span style={{ display:"inline-flex", alignItems:"center", gap:5, background:c.bg, border:"1px solid " + c.border, color:c.text, fontSize:11, fontWeight:600, padding:"3px 10px", borderRadius:20, fontFamily:"'Plus Jakarta Sans',sans-serif", textTransform:"capitalize" }}><span style={{ width:6,height:6,borderRadius:"50%",background:c.dot,boxShadow:"0 0 5px " + c.dot }} />{status}</span>;
}
function CatPill({ cat, small }) {
  const col = CAT_COLOR[cat]||"#94a3b8";
  return <span style={{ display:"inline-flex", alignItems:"center", gap:4, background:col+"18", border:"1px solid " + col+"40", color:col, fontSize:small?10:11, fontWeight:600, padding:small?"2px 7px":"3px 10px", borderRadius:20, fontFamily:"'Plus Jakarta Sans',sans-serif", whiteSpace:"nowrap" }}>{CAT_ICONS[cat]} {cat}</span>;
}
function Toast({ msg }) {
  return <div style={{ position:"fixed", bottom:24, left:"50%", transform:"translateX(-50%)", background:BG3, color:ORL, fontFamily:"'Bebas Neue',sans-serif", fontSize:15, letterSpacing:2, padding:"12px 28px", borderRadius:10, border:"2px solid " + OR, zIndex:9999, boxShadow:"0 4px 40px var(--brand-or-25)", animation:"fadeUp .3s ease", whiteSpace:"nowrap" }}>{msg}</div>;
}
function Avatar({ name, size=28 }) {
  const initials = name.split(" ").map(w=>w[0]).join("").toUpperCase().slice(0,2);
  const hue = name.split("").reduce((a,c)=>a+c.charCodeAt(0),0)%360;
  return <div style={{ width:size, height:size, borderRadius:"50%", background:"hsl("+hue+",40%,22%)", border:"2px solid hsl("+hue+",55%,42%)", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:size*.38, fontWeight:700, color:"hsl("+hue+",70%,75%)", flexShrink:0 }}>{initials}</div>;
}
function Spinner() {
  return <div style={{ display:"flex", justifyContent:"center", padding:"48px 0" }}><div style={{ width:36, height:36, border:"3px solid " + OR, borderTopColor:"transparent", borderRadius:"50%", animation:"spin .7s linear infinite" }} /></div>;
}
function BarChart({ data, colorKey }) {
  if (!data.length) return null;
  const max = Math.max(...data.map(d=>d.value),1);
  return (
    <div style={{ display:"flex", alignItems:"flex-end", gap:3, height:56 }}>
      {data.map((d,i)=>(
        <div key={i} style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", gap:2 }}>
          <div style={{ width:"100%", background:(colorKey?CAT_COLOR[d.label]:null)||OR, borderRadius:"3px 3px 0 0", height:Math.max(4,(d.value/max)*100)+"%", opacity:.85, minHeight:4 }} />
          <div style={{ color:DIM, fontSize:8, fontFamily:"'Plus Jakarta Sans',sans-serif", textAlign:"center", maxWidth:28, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{d.label}</div>
        </div>
      ))}
    </div>
  );
}
function ProgressRing({ pct, size=70, stale }) {
  const r=(size-10)/2, circ=2*Math.PI*r, dash=(pct/100)*circ;
  const color=stale?"#ef4444":pct>80?OR:"#4ade80";
  return (
    <svg width={size} height={size} style={{ transform:"rotate(-90deg)" }}>
      <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={BG4} strokeWidth={8} />
      <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={color} strokeWidth={8} strokeDasharray={dash + " " + circ} strokeLinecap="round" />
      <text x={size/2} y={size/2} textAnchor="middle" dominantBaseline="central" style={{ fill:color, fontSize:14, fontWeight:700, fontFamily:"'Bebas Neue',sans-serif", transform:"rotate(90deg)", transformOrigin:"center" }}>{pct}%</text>
    </svg>
  );
}

// ── ADMIN MODAL ───────────────────────────────────────────────────────────────
function AdminModal({ onClose, onSuccess, adminPassword, onChangePassword }) {
  const [pw,setPw]=useState(""); const [error,setError]=useState("");
  const [tab,setTab]=useState("login");
  const [newPw,setNewPw]=useState(""); const [newPw2,setNewPw2]=useState(""); const [cpMsg,setCpMsg]=useState("");
  const tryLogin=()=>{ if(pw===adminPassword){onSuccess();onClose();}else{setError("Incorrect password");setPw("");} };
  const tryChange=()=>{
    if(!newPw.trim()){setCpMsg("Enter a new password");return;}
    if(newPw!==newPw2){setCpMsg("Passwords don't match");return;}
    if(newPw.length<4){setCpMsg("Must be at least 4 characters");return;}
    onChangePassword(newPw); setCpMsg("✓ Password updated!"); setNewPw(""); setNewPw2("");
  };
  const mi={ width:"100%", background:BG3, border:"1px solid " + BG4, color:TEXT, borderRadius:9, padding:"12px 14px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:15, outline:"none", marginBottom:10 };
  return (
    <div onClick={onClose} style={{ position:"fixed", inset:0, background:"#000d", zIndex:9100, display:"flex", alignItems:"flex-end", justifyContent:"center" }}>
      <div onClick={e=>e.stopPropagation()} style={{ background:BG2, border:"1px solid " + BG4, borderRadius:"18px 18px 0 0", width:"100%", maxWidth:480, padding:"28px 22px 40px", animation:"slideUp .25s ease" }}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:6 }}>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}><span style={{ fontSize:22 }}>🔐</span><span style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:22, color:OR, letterSpacing:2 }}>ADMIN ACCESS</span></div>
          <button onClick={onClose} style={{ background:"none", border:"none", color:MUTED, fontSize:20, cursor:"pointer" }}>✕</button>
        </div>
        <p style={{ color:MUTED, fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:20 }}>Owner-only area. Enter your admin password to unlock.</p>
        <div style={{ display:"flex", gap:0, marginBottom:20, borderBottom:"1px solid " + BG4 }}>
          {[["login","Login"],["change","Change Password"]].map(([id,label])=>(
            <button key={id} onClick={()=>setTab(id)} style={{ flex:1, background:"none", border:"none", borderBottom:"2px solid " + (tab===id?OR:"transparent"), color:tab===id?OR:MUTED, padding:"8px 0", fontFamily:"'Bebas Neue',sans-serif", fontSize:13, letterSpacing:2, cursor:"pointer" }}>{label}</button>
          ))}
        </div>
        {tab==="login" && (<>
          <input type="password" value={pw} onChange={e=>{setPw(e.target.value);setError("");}} onKeyDown={e=>e.key==="Enter"&&tryLogin()} placeholder="Enter password" style={mi} autoFocus />
          {error&&<div style={{ color:"#ef4444", fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:10 }}>⚠️ {error}</div>}
          <button onClick={tryLogin} style={{ width:"100%", background:"linear-gradient(135deg," + OR + "," + ORD + ")", color:"#fff", border:"none", borderRadius:10, padding:"14px", fontFamily:"'Bebas Neue',sans-serif", fontSize:18, letterSpacing:2, cursor:"pointer", boxShadow:"0 4px 20px var(--brand-or-25)" }}>UNLOCK ADMIN</button>
          <div style={{ marginTop:14, padding:"12px 14px", background:BG3, borderRadius:9, border:"1px solid " + BG4 }}>
            <div style={{ color:MUTED, fontSize:11, fontFamily:"'Plus Jakarta Sans',sans-serif", lineHeight:1.6 }}>💡 Default password is <span style={{ color:OR, fontWeight:700 }}>beamshots</span> — change it after first login.</div>
          </div>
        </>)}
        {tab==="change" && (<>
          {[["CURRENT PASSWORD",pw,e=>setPw(e.target.value),"Current password"],["NEW PASSWORD",newPw,e=>setNewPw(e.target.value),"New password"],["CONFIRM NEW PASSWORD",newPw2,e=>setNewPw2(e.target.value),"Confirm new password"]].map(([label,val,onChange,ph])=>(
            <div key={label}><div style={{ color:MUTED, fontSize:11, letterSpacing:2, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:6 }}>{label}</div><input type="password" value={val} onChange={onChange} placeholder={ph} style={mi} /></div>
          ))}
          {cpMsg&&<div style={{ color:cpMsg.startsWith("✓")?"#4ade80":"#ef4444", fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:10 }}>{cpMsg}</div>}
          <button onClick={()=>{ if(pw!==adminPassword){setCpMsg("Current password incorrect");return;} tryChange(); }} style={{ width:"100%", background:"linear-gradient(135deg," + OR + "," + ORD + ")", color:"#fff", border:"none", borderRadius:10, padding:"14px", fontFamily:"'Bebas Neue',sans-serif", fontSize:18, letterSpacing:2, cursor:"pointer" }}>UPDATE PASSWORD</button>
        </>)}
      </div>
    </div>
  );
}

// ── LOGO CROP MODAL ───────────────────────────────────────────────────────────
function LogoCropModal({ file, onConfirm, onCancel }) {
  const cropCanvasRef = useRef();
  const imgRef        = useRef(null);
  const dragRef       = useRef(null);
  const [imageReady,  setImageReady]  = useState(false);
  const [crop,        setCrop]        = useState({ x:0, y:0, w:0, h:0 });

  useEffect(() => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      imgRef.current = img;
      const canvas   = cropCanvasRef.current;
      const maxW     = 440;
      const sc       = Math.min(1, maxW / img.width);
      canvas.width   = Math.round(img.width  * sc);
      canvas.height  = Math.round(img.height * sc);
      const sz = Math.round(Math.min(canvas.width, canvas.height) * 0.8);
      setCrop({ x: Math.round((canvas.width - sz) / 2), y: Math.round((canvas.height - sz) / 2), w: sz, h: sz });
      setImageReady(true);
    };
    img.src = url;
    return () => URL.revokeObjectURL(url);
  }, [file]);

  useEffect(() => {
    if (!imageReady || !cropCanvasRef.current || !imgRef.current) return;
    const canvas = cropCanvasRef.current;
    const ctx    = canvas.getContext("2d");
    const { width: cw, height: ch } = canvas;
    ctx.clearRect(0, 0, cw, ch);
    ctx.drawImage(imgRef.current, 0, 0, cw, ch);
    const { x, y, w, h } = crop;
    ctx.fillStyle = "rgba(0,0,0,0.55)";
    ctx.fillRect(0,   0,   cw,          y);
    ctx.fillRect(0,   y+h, cw,          ch-y-h);
    ctx.fillRect(0,   y,   x,           h);
    ctx.fillRect(x+w, y,   cw-(x+w),    h);
    ctx.strokeStyle = "#f97316";
    ctx.lineWidth   = 2;
    ctx.strokeRect(x, y, w, h);
    const hs = 14;
    ctx.fillStyle = "#f97316";
    ctx.fillRect(x,       y,       hs, hs);
    ctx.fillRect(x+w-hs,  y,       hs, hs);
    ctx.fillRect(x,       y+h-hs,  hs, hs);
    ctx.fillRect(x+w-hs,  y+h-hs,  hs, hs);
  }, [imageReady, crop]);

  const getCanvasPos = (e) => {
    const canvas = cropCanvasRef.current;
    const rect   = canvas.getBoundingClientRect();
    const src    = e.touches ? e.touches[0] : e;
    return {
      x: (src.clientX - rect.left)  * (canvas.width  / rect.width),
      y: (src.clientY - rect.top)   * (canvas.height / rect.height),
    };
  };

  const HIT = 24;

  const onDown = (e) => {
    if (!imageReady) return;
    e.preventDefault();
    const pos = getCanvasPos(e);
    const { x, y, w, h } = crop;
    let type = "move";
    if (pos.x <= x+HIT   && pos.y <= y+HIT)   type = "tl";
    else if (pos.x >= x+w-HIT && pos.y <= y+HIT)   type = "tr";
    else if (pos.x <= x+HIT   && pos.y >= y+h-HIT) type = "bl";
    else if (pos.x >= x+w-HIT && pos.y >= y+h-HIT) type = "br";
    dragRef.current = { type, sx: pos.x, sy: pos.y, sc: { ...crop } };
  };

  const onMove = (e) => {
    if (!dragRef.current || !imageReady || !cropCanvasRef.current) return;
    e.preventDefault();
    const pos = getCanvasPos(e);
    const { type, sx, sy, sc } = dragRef.current;
    const dx = pos.x - sx;
    const dy = pos.y - sy;
    const { width: cw, height: ch } = cropCanvasRef.current;
    const MIN = 40;
    setCrop(() => {
      if (type === "move") return { ...sc, x: Math.max(0, Math.min(cw-sc.w, sc.x+dx)), y: Math.max(0, Math.min(ch-sc.h, sc.y+dy)) };
      if (type === "br")   return { ...sc, w: Math.max(MIN, Math.min(cw-sc.x, sc.w+dx)), h: Math.max(MIN, Math.min(ch-sc.y, sc.h+dy)) };
      if (type === "tl") { const nx=Math.max(0,Math.min(sc.x+sc.w-MIN,sc.x+dx)); const ny=Math.max(0,Math.min(sc.y+sc.h-MIN,sc.y+dy)); return { x:nx, y:ny, w:sc.x+sc.w-nx, h:sc.y+sc.h-ny }; }
      if (type === "tr") { const ny=Math.max(0,Math.min(sc.y+sc.h-MIN,sc.y+dy)); return { x:sc.x, y:ny, w:Math.max(MIN,Math.min(cw-sc.x,sc.w+dx)), h:sc.y+sc.h-ny }; }
      if (type === "bl") { const nx=Math.max(0,Math.min(sc.x+sc.w-MIN,sc.x+dx)); return { x:nx, y:sc.y, w:sc.x+sc.w-nx, h:Math.max(MIN,Math.min(ch-sc.y,sc.h+dy)) }; }
      return sc;
    });
  };

  const onUp = () => { dragRef.current = null; };

  const handleConfirm = () => {
    const img   = imgRef.current;
    const canvas = cropCanvasRef.current;
    const scale = img.width / canvas.width;
    const out   = document.createElement("canvas");
    out.width   = Math.round(crop.w * scale);
    out.height  = Math.round(crop.h * scale);
    out.getContext("2d").drawImage(img,
      Math.round(crop.x * scale), Math.round(crop.y * scale), out.width, out.height,
      0, 0, out.width, out.height
    );
    out.toBlob(blob => onConfirm(blob), "image/png", 0.92);
  };

  return (
    <div style={{ position:"fixed", inset:0, background:"#000e", zIndex:9200, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:16 }}>
      <div style={{ background:BG2, border:"1px solid " + BG4, borderRadius:16, width:"100%", maxWidth:480, overflow:"hidden" }}>
        <div style={{ padding:"16px 20px", borderBottom:"1px solid " + BG4, display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <span style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:20, color:OR, letterSpacing:2 }}>CROP YOUR LOGO</span>
          <button onClick={onCancel} style={{ background:"none", border:"none", color:MUTED, fontSize:20, cursor:"pointer" }}>✕</button>
        </div>
        <div style={{ padding:16, background:BG3, minHeight:160 }}>
          <div style={{ color:MUTED, fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:8, textAlign:"center" }}>Drag to move · Drag orange corners to resize</div>
          <canvas
            ref={cropCanvasRef}
            style={{ width:"100%", display:imageReady?"block":"none", touchAction:"none", cursor:"crosshair", borderRadius:8 }}
            onMouseDown={onDown} onMouseMove={onMove} onMouseUp={onUp} onMouseLeave={onUp}
            onTouchStart={onDown} onTouchMove={onMove} onTouchEnd={onUp}
          />
          {!imageReady && <Spinner />}
        </div>
        <div style={{ padding:"16px 20px", display:"flex", gap:10 }}>
          <button onClick={onCancel} style={{ flex:1, background:BG3, border:"1px solid " + BG4, color:MUTED, borderRadius:10, padding:"13px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:14, cursor:"pointer" }}>Cancel</button>
          <button onClick={handleConfirm} disabled={!imageReady} style={{ flex:2, background:"linear-gradient(135deg," + OR + "," + ORD + ")", color:"#fff", border:"none", borderRadius:10, padding:"13px", fontFamily:"'Bebas Neue',sans-serif", fontSize:16, letterSpacing:2, cursor:"pointer", opacity:imageReady?1:0.5 }}>USE THIS CROP</button>
        </div>
      </div>
    </div>
  );
}

// ── DROP ZONE ─────────────────────────────────────────────────────────────────
function DropZone({ onFiles }) {
  const [drag,setDrag]=useState(false);
  const inp=useRef();
  const handle=useCallback(files=>{ const imgs=Array.from(files).filter(f=>f.type.startsWith("image/")); if(imgs.length) onFiles(imgs); },[onFiles]);
  return (
    <div onDragOver={e=>{e.preventDefault();setDrag(true);}} onDragLeave={()=>setDrag(false)}
      onDrop={e=>{e.preventDefault();setDrag(false);handle(e.dataTransfer.files);}} onClick={()=>inp.current.click()}
      style={{ border:"2px dashed " + (drag?OR:BG4), borderRadius:12, padding:"28px 20px", textAlign:"center", cursor:"pointer", background:drag?"var(--brand-or-05)":BG2, transition:"all .2s", marginBottom:20 }}>
      <div style={{ fontSize:32, marginBottom:6 }}>📸</div>
      <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:17, color:OR, letterSpacing:3 }}>DROP PHOTOS HERE</div>
      <div style={{ color:MUTED, fontSize:12, marginTop:3, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>or tap to select from your device</div>
      <input ref={inp} type="file" accept="image/*" multiple style={{ display:"none" }} onChange={e=>handle(e.target.files)} />
    </div>
  );
}

// ── PHOTO CARD ────────────────────────────────────────────────────────────────
function PhotoCard({ photo, onDelete, onUpdate, isAdmin, allCategories }) {
  const [zoomed,setZoomed]=useState(false);
  const [editing,setEditing]=useState(false);
  const [noteVal,setNoteVal]=useState(photo.note||"");
  const [catVal,setCatVal]=useState(photo.suggested_category&&!photo.category_confirmed?photo.suggested_category:photo.category||"General");
  const save=()=>{ onUpdate(photo.id,{note:noteVal,category:catVal,category_confirmed:true}); setEditing(false); };
  const imgUrl = photo.image_url || photo.dataUrl || "";
  return (<>
    <div style={{ background:BG2, border:"1px solid " + BG4, borderRadius:10, overflow:"hidden", position:"relative", transition:"transform .18s" }}
      onMouseEnter={e=>e.currentTarget.style.transform="translateY(-2px)"} onMouseLeave={e=>e.currentTarget.style.transform="translateY(0)"}>
      <div onClick={()=>setZoomed(true)} style={{ position:"relative", paddingTop:"72%", background:BG3, cursor:"zoom-in" }}>
        {imgUrl ? <img src={imgUrl} alt={photo.name} style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover" }} />
          : <div style={{ position:"absolute", inset:0, display:"flex", alignItems:"center", justifyContent:"center", fontSize:28, opacity:.2 }}>{CAT_ICONS[photo.category||"General"]}</div>}
        <div style={{ position:"absolute", top:6, left:6, display:"flex", alignItems:"center", gap:4 }}>
          <CatPill cat={photo.category||"General"} small />
          {photo.suggested_category&&!photo.category_confirmed&&<span style={{ background:"#f9731699", color:"#fff", fontSize:9, padding:"2px 5px", borderRadius:10, fontWeight:700, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>⚡ AI</span>}
        </div>
      </div>
      <div style={{ padding:"9px 10px 10px" }}>
        <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:5 }}>
          <Avatar name={photo.uploader_name||"?"} size={22} />
          <span style={{ color:OR, fontSize:11, fontFamily:"'Plus Jakarta Sans',sans-serif", fontWeight:700 }}>{photo.uploader_name||"Unknown"}</span>
          <span style={{ color:DIM, fontSize:10, fontFamily:"'Plus Jakarta Sans',sans-serif", marginLeft:"auto" }}>{fmtD(photo.created_at)}</span>
        </div>
        {photo.note&&!editing&&<p style={{ color:MUTED, fontSize:11, lineHeight:1.55, marginBottom:6, background:BG3, borderRadius:6, padding:"5px 8px", fontFamily:"'Plus Jakarta Sans',sans-serif" }}>💬 {photo.note}</p>}
        {photo.suggested_category&&!photo.category_confirmed&&!editing&&(
          <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", background:"#1a1505", border:"1px solid var(--brand-or-25)", borderRadius:6, padding:"5px 8px", marginBottom:5 }}>
            <span style={{ color:ORL, fontSize:10, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>{"⚡ " + photo.suggested_category}</span>
            <div style={{ display:"flex", gap:4 }}>
              <button onClick={e=>{e.stopPropagation();onUpdate(photo.id,{category:photo.suggested_category,category_confirmed:true});}} style={{ background:"#276627", border:"none", color:"#4ade80", width:20, height:20, borderRadius:4, cursor:"pointer", fontSize:12, display:"flex", alignItems:"center", justifyContent:"center" }}>✓</button>
              <button onClick={e=>{e.stopPropagation();onUpdate(photo.id,{category_confirmed:true});}} style={{ background:BG3, border:"1px solid " + BG4, color:DIM, width:20, height:20, borderRadius:4, cursor:"pointer", fontSize:11, display:"flex", alignItems:"center", justifyContent:"center" }}>✕</button>
            </div>
          </div>
        )}
        {editing ? (
          <div onClick={e=>e.stopPropagation()}>
            <select value={catVal} onChange={e=>setCatVal(e.target.value)} style={{ width:"100%", background:BG3, border:"1px solid " + BG4, color:TEXT, borderRadius:7, padding:"6px 8px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:12, marginBottom:7 }}>
              {(allCategories||CATEGORIES).map(c=><option key={c} value={c}>{CAT_ICONS[c]||"📷"} {c}</option>)}
            </select>
            <textarea value={noteVal} onChange={e=>setNoteVal(e.target.value)} placeholder="Add a note..." rows={2}
              style={{ width:"100%", background:BG3, border:"1px solid " + BG4, color:TEXT, borderRadius:7, padding:"6px 8px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:12, resize:"none", marginBottom:7, outline:"none" }} />
            <div style={{ display:"flex", gap:6 }}>
              <button onClick={save} style={{ flex:1, background:"linear-gradient(135deg," + OR + "," + ORD + ")", border:"none", color:"#fff", borderRadius:6, padding:"6px", fontFamily:"'Bebas Neue',sans-serif", fontSize:13, letterSpacing:1, cursor:"pointer" }}>SAVE</button>
              <button onClick={()=>setEditing(false)} style={{ flex:1, background:BG3, border:"1px solid " + BG4, color:MUTED, borderRadius:6, padding:"6px", fontSize:12, cursor:"pointer", fontFamily:"'Plus Jakarta Sans',sans-serif" }}>Cancel</button>
            </div>
          </div>
        ) : (
          <button onClick={e=>{e.stopPropagation();setEditing(true);}} style={{ width:"100%", background:BG3, border:"1px solid " + BG4, color:MUTED, borderRadius:7, padding:"5px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:11, cursor:"pointer", marginTop:2 }}>
            {photo.note?"✏️ Edit note":"＋ Add note / category"}
          </button>
        )}
      </div>
      {isAdmin&&<button onClick={e=>{e.stopPropagation();onDelete(photo.id);}} style={{ position:"absolute", top:6, right:6, background:"#000b", border:"none", color:"#ef4444", width:22, height:22, borderRadius:"50%", cursor:"pointer", fontSize:11, display:"flex", alignItems:"center", justifyContent:"center" }}>✕</button>}
    </div>
    {zoomed&&<div onClick={()=>setZoomed(false)} style={{ position:"fixed", inset:0, background:"#000e", zIndex:9098, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:12 }}>
      {imgUrl&&<img src={imgUrl} alt={photo.name} style={{ maxWidth:"95vw", maxHeight:"80vh", borderRadius:10, boxShadow:"0 12px 80px #000c" }} />}
      {photo.note&&<div style={{ background:"#000c", color:TEXT, fontSize:13, padding:"8px 18px", borderRadius:20, fontFamily:"'Plus Jakarta Sans',sans-serif", maxWidth:"80vw", textAlign:"center" }}>💬 {photo.note}</div>}
    </div>}
  </>);
}

// ── CREW MODAL ────────────────────────────────────────────────────────────────
function CrewModal({ job, onClose, onSave }) {
  const [members,setMembers]=useState(job.crew||[]);
  const [input,setInput]=useState("");
  const add=()=>{ const n=input.trim(); if(n&&!members.includes(n)) setMembers(m=>[...m,n]); setInput(""); };
  return (
    <div onClick={onClose} style={{ position:"fixed", inset:0, background:"#000c", zIndex:9000, display:"flex", alignItems:"flex-end", justifyContent:"center" }}>
      <div onClick={e=>e.stopPropagation()} style={{ background:BG2, border:"1px solid " + BG4, borderRadius:"16px 16px 0 0", width:"100%", maxWidth:480, padding:"24px 20px 36px", animation:"slideUp .25s ease" }}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:20 }}>
          <span style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:22, color:TEXT, letterSpacing:2 }}>CREW ROSTER</span>
          <button onClick={onClose} style={{ background:"none", border:"none", color:MUTED, fontSize:20, cursor:"pointer" }}>✕</button>
        </div>
        <div style={{ display:"flex", flexDirection:"column", gap:8, marginBottom:16 }}>
          {members.length===0&&<div style={{ color:DIM, fontSize:13, textAlign:"center", padding:"12px 0", fontFamily:"'Plus Jakarta Sans',sans-serif" }}>No crew added yet</div>}
          {members.map(m=>(
            <div key={m} style={{ display:"flex", alignItems:"center", gap:10, background:BG3, border:"1px solid " + BG4, borderRadius:9, padding:"9px 12px" }}>
              <Avatar name={m} size={32} /><span style={{ color:TEXT, fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:14, fontWeight:600, flex:1 }}>{m}</span>
              <button onClick={()=>setMembers(members.filter(x=>x!==m))} style={{ background:"none", border:"none", color:"#ef4444", fontSize:14, cursor:"pointer" }}>✕</button>
            </div>
          ))}
        </div>
        <div style={{ display:"flex", gap:8, marginBottom:20 }}>
          <input value={input} onChange={e=>setInput(e.target.value)} onKeyDown={e=>e.key==="Enter"&&add()} placeholder="Crew member name..."
            style={{ flex:1, background:BG3, border:"1px solid " + BG4, color:TEXT, borderRadius:9, padding:"10px 12px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:14, outline:"none" }} />
          <button onClick={add} style={{ background:"linear-gradient(135deg," + OR + "," + ORD + ")", color:"#fff", border:"none", borderRadius:9, padding:"10px 16px", fontFamily:"'Bebas Neue',sans-serif", fontSize:14, letterSpacing:1, cursor:"pointer" }}>ADD</button>
        </div>
        <button onClick={()=>onSave(members)} style={{ width:"100%", background:"linear-gradient(135deg," + OR + "," + ORD + ")", color:"#fff", border:"none", borderRadius:10, padding:"13px", fontFamily:"'Bebas Neue',sans-serif", fontSize:17, letterSpacing:2, cursor:"pointer", boxShadow:"0 4px 20px var(--brand-or-25)" }}>SAVE ROSTER</button>
      </div>
    </div>
  );
}

// ── ANALYTICS ─────────────────────────────────────────────────────────────────
function JobAnalyticsPanel({ job, photos, staleThreshold, staleAlertsEnabled, allCategories }) {
  const a=buildJobAnalytics(job,photos,staleThreshold,staleAlertsEnabled,allCategories);
  const catData=Object.entries(a.byCat).map(([label,v])=>({label,value:v.count,span:v.spanDays}));
  const dayData=Object.entries(a.byDay).sort((x,y)=>x[0]<y[0]?-1:1).slice(-14).map(([d,v])=>({label:d.slice(5),value:v}));
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:12, marginBottom:24 }}>
      <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:16, color:OR, letterSpacing:3, marginBottom:4 }}>📊 JOB ANALYTICS</div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8 }}>
        <div style={{ background:BG2, border:"1px solid " + BG4, borderRadius:10, padding:"12px 10px", textAlign:"center" }}>
          {a.pctTime!==null?<ProgressRing pct={a.pctTime} size={64} stale={a.momentum==="stale"} />:<div style={{ color:MUTED, fontSize:11 }}>No estimate</div>}
          <div style={{ color:MUTED, fontSize:10, fontFamily:"'Plus Jakarta Sans',sans-serif", marginTop:5, letterSpacing:1 }}>TIME USED</div>
          <div style={{ color:TEXT, fontSize:10 }}>{a.elapsedDays}d / {job.estimated_days||"?"}d</div>
        </div>
        <div style={{ background:a.momentum==="stale"?"#2a0a0a":"#142010", border:"1px solid " + (a.momentum==="stale"?"#6b1515":"#276627"), borderRadius:10, padding:"12px 10px", textAlign:"center", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:4 }}>
          <div style={{ fontSize:26 }}>{a.momentum==="stale"?"🔴":"🟢"}</div>
          <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:14, color:a.momentum==="stale"?"#ef4444":"#4ade80", letterSpacing:1 }}>{a.momentum==="stale"?"STALE":"ACTIVE"}</div>
          <div style={{ color:MUTED, fontSize:10 }}>{a.staleDays===0?"Photo today":a.staleDays+"d since photo"}</div>
        </div>
        <div style={{ background:BG2, border:"1px solid " + BG4, borderRadius:10, padding:"12px 10px", textAlign:"center", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:4 }}>
          <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:28, color:OR }}>{a.totalPhotos}</div>
          <div style={{ color:MUTED, fontSize:10, letterSpacing:1 }}>TOTAL PHOTOS</div>
          <div style={{ color:DIM, fontSize:10 }}>{a.totalPhotos>0?"Last " + fmtD(a.lastPhotoTs):"None yet"}</div>
        </div>
      </div>
      {dayData.length>0&&<div style={{ background:BG2, border:"1px solid " + BG4, borderRadius:10, padding:"14px 14px 10px" }}><div style={{ color:MUTED, fontSize:10, letterSpacing:2, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:10 }}>UPLOAD ACTIVITY (LAST 14 DAYS)</div><BarChart data={dayData} colorKey={false} /></div>}
      {catData.length>0&&<div style={{ background:BG2, border:"1px solid " + BG4, borderRadius:10, padding:"14px" }}><div style={{ color:MUTED, fontSize:10, letterSpacing:2, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:12 }}>TIME SPENT PER PHASE</div><div style={{ display:"flex", flexDirection:"column", gap:8 }}>{catData.sort((a,b)=>b.span-a.span).map(c=>(<div key={c.label}><div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}><CatPill cat={c.label} small /><span style={{ color:MUTED, fontSize:11 }}>{c.span} day{c.span!==1?"s":""} · {c.value} photo{c.value!==1?"s":""}</span></div><div style={{ height:5, background:BG4, borderRadius:3, overflow:"hidden" }}><div style={{ height:"100%", width:Math.min(100,(c.span/Math.max(...catData.map(x=>x.span),1))*100)+"%", background:CAT_COLOR[c.label]||OR, borderRadius:3 }} /></div></div>))}</div></div>}
    </div>
  );
}

function AnalyticsDashboard({ jobs, photos, staleThreshold, staleAlertsEnabled, allCategories }) {
  const analytics=jobs.map(j=>({job:j,...buildJobAnalytics(j,photos,staleThreshold,staleAlertsEnabled,allCategories)}));
  const staleJobs=analytics.filter(a=>a.momentum==="stale"&&a.job.status==="active");
  const overTime=analytics.filter(a=>a.pctTime!==null&&a.pctTime>=100&&a.job.status==="active");
  const globalCatCounts={};
  (allCategories||CATEGORIES).forEach(c=>{ const n=photos.filter(p=>(p.category||"General")===c).length; if(n) globalCatCounts[c]=n; });
  const globalCatData=Object.entries(globalCatCounts).map(([label,value])=>({label,value}));
  return (
    <div style={{ padding:"20px 16px 40px" }}>
      <h1 style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:32, color:TEXT, letterSpacing:2, marginBottom:4 }}>ANALYTICS</h1>
      <div style={{ width:44, height:3, background:"linear-gradient(90deg," + ORD + "," + ORL + ")", borderRadius:2, marginBottom:16 }} />
      <p style={{ color:MUTED, fontSize:13, marginBottom:22, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>Overview across all {jobs.length} job sites</p>
      {(staleJobs.length>0||overTime.length>0)&&<div style={{ background:"#2a1505", border:"1px solid var(--brand-or-25)", borderRadius:12, padding:"14px 16px", marginBottom:20 }}><div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:14, color:OR, letterSpacing:2, marginBottom:8 }}>⚠️ ATTENTION NEEDED</div>{staleJobs.map(a=><div key={a.job.id} style={{ color:"#ef4444", fontSize:11, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:4 }}>🔴 <b>{a.job.name}</b> — no photos for {a.staleDays} days</div>)}{overTime.map(a=><div key={a.job.id} style={{ color:ORL, fontSize:11, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:4 }}>⏱️ <b>{a.job.name}</b> — {a.elapsedDays}d elapsed, {a.pctTime}% of estimate used</div>)}</div>}
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:16 }}>
        {[{label:"ACTIVE SITES",value:jobs.filter(j=>j.status==="active").length,color:"#4ade80"},{label:"TOTAL PHOTOS",value:photos.length,color:OR},{label:"STALE SITES",value:staleJobs.length,color:staleJobs.length>0?"#ef4444":"#4ade80"},{label:"OVER ESTIMATE",value:overTime.length,color:overTime.length>0?OR:"#4ade80"}].map(s=>(
          <div key={s.label} style={{ background:BG2, border:"1px solid " + BG4, borderRadius:10, padding:"14px", textAlign:"center" }}>
            <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:32, color:s.color }}>{s.value}</div>
            <div style={{ color:DIM, fontSize:10, letterSpacing:2, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>{s.label}</div>
          </div>
        ))}
      </div>
      {globalCatData.length>0&&<div style={{ background:BG2, border:"1px solid " + BG4, borderRadius:12, padding:"16px", marginBottom:16 }}><div style={{ color:MUTED, fontSize:10, letterSpacing:2, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:12 }}>PHOTOS BY PHASE — ALL SITES</div><BarChart data={globalCatData} colorKey /></div>}
      <div style={{ color:MUTED, fontSize:10, letterSpacing:2, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:10 }}>JOB-BY-JOB STATUS</div>
      <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
        {analytics.map(a=>(
          <div key={a.job.id} style={{ background:BG2, border:"1px solid " + (a.momentum==="stale"&&a.job.status==="active"?"#6b1515":BG4), borderRadius:12, padding:"14px 16px" }}>
            <div style={{ display:"flex", alignItems:"flex-start", justifyContent:"space-between", marginBottom:8 }}>
              <div><div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:18, color:TEXT, letterSpacing:1 }}>{a.job.name}</div><div style={{ color:DIM, fontSize:11 }}>{a.job.address}</div></div>
              <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:4 }}><StatusBadge status={a.job.status} />{a.momentum==="stale"&&a.job.status==="active"&&<span style={{ color:"#ef4444", fontSize:10, fontWeight:700 }}>⚠️ {a.staleDays}d no activity</span>}</div>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8, fontSize:11, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
              <div style={{ color:MUTED }}>⏱ <span style={{ color:TEXT }}>{a.elapsedDays}d elapsed</span></div>
              <div style={{ color:MUTED }}>🎯 <span style={{ color:TEXT }}>{a.job.estimated_days||"?"}d est.</span></div>
              <div style={{ color:MUTED }}>📸 <span style={{ color:TEXT }}>{a.totalPhotos} photos</span></div>
            </div>
            {a.pctTime!==null&&<div style={{ marginTop:10 }}><div style={{ height:5, background:BG4, borderRadius:3, overflow:"hidden" }}><div style={{ height:"100%", width:Math.min(100,a.pctTime)+"%", background:a.pctTime>=100?"#ef4444":a.pctTime>=80?OR:"#4ade80", borderRadius:3 }} /></div><div style={{ color:DIM, fontSize:10, marginTop:3, textAlign:"right" }}>{a.pctTime}% of time estimate used</div></div>}
          </div>
        ))}
      </div>
    </div>
  );
}

// ── CHURN INSIGHTS ────────────────────────────────────────────────────────────
function ChurnScreen() {
  const [loading,   setLoading]   = useState(true);
  const [churnData, setChurnData] = useState(null);
  const [err,       setErr]       = useState("");

  useEffect(()=>{
    const load = async () => {
      try {
        const { data: res, error } = await supabase.functions.invoke("get-churn-insights");
        if (error) { setErr(error.message || "Failed to load"); setLoading(false); return; }
        setChurnData(res);
      } catch (e) { setErr(e.message || "Unknown error"); }
      setLoading(false);
    };
    load();
  },[]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) return <Spinner />;
  if (err) return <div style={{ padding:"24px 16px", color:"#ef4444", fontFamily:"'Plus Jakarta Sans',sans-serif" }}>Error: {err}</div>;
  if (!churnData) return null;

  const reasonChart = Object.entries(churnData.aggregated || {}).sort((a,b)=>b[1]-a[1]).map(([label,value])=>({ label, value }));

  return (
    <div style={{ padding:"24px 16px 80px", animation:"fadeIn .25s ease" }}>
      <h2 style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:28, color:TEXT, letterSpacing:2, marginBottom:4 }}>CHURN INSIGHTS</h2>
      <div style={{ width:40, height:3, background:"linear-gradient(90deg," + ORD + "," + ORL + ")", borderRadius:2, marginBottom:20 }} />
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:20 }}>
        <div style={{ background:BG2, border:"1px solid " + BG4, borderRadius:12, padding:"16px" }}>
          <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:32, color:OR }}>{churnData.total}</div>
          <div style={{ color:MUTED, fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>Total cancellations</div>
        </div>
        {Object.entries(churnData.byPlan || {}).map(([pln, cnt])=>(
          <div key={pln} style={{ background:BG2, border:"1px solid " + BG4, borderRadius:12, padding:"16px" }}>
            <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:32, color:ORL }}>{cnt}</div>
            <div style={{ color:MUTED, fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>{pln}</div>
          </div>
        ))}
      </div>
      {reasonChart.length > 0 && (
        <div style={{ background:BG2, border:"1px solid " + BG4, borderRadius:14, padding:"20px", marginBottom:16 }}>
          <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:14, color:OR, letterSpacing:3, marginBottom:14 }}>TOP REASONS</div>
          <BarChart data={reasonChart} colorKey={false} />
          <div style={{ marginTop:16, display:"flex", flexDirection:"column", gap:8 }}>
            {reasonChart.map(({label, value})=>(
              <div key={label} style={{ display:"flex", alignItems:"center", justifyContent:"space-between" }}>
                <span style={{ color:MUTED, fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>{label}</span>
                <span style={{ color:OR, fontFamily:"'Bebas Neue',sans-serif", fontSize:16 }}>{value}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      <div style={{ background:BG2, border:"1px solid " + BG4, borderRadius:14, padding:"20px" }}>
        <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:14, color:OR, letterSpacing:3, marginBottom:14 }}>RECENT CANCELLATIONS</div>
        {(churnData.recent || []).length === 0 && <div style={{ color:DIM, fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>No cancellations yet.</div>}
        {(churnData.recent || []).map((row,i)=>(
          <div key={i} style={{ borderTop:i>0?"1px solid "+BG4:"none", paddingTop:i>0?14:0, marginTop:i>0?14:0 }}>
            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
              <span style={{ color:ORL, fontSize:12, fontFamily:"'Bebas Neue',sans-serif", letterSpacing:1 }}>{(row.plan||"?").toUpperCase()}</span>
              <span style={{ color:DIM, fontSize:11, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>{new Date(row.canceled_at).toLocaleDateString()}</span>
            </div>
            <div style={{ color:MUTED, fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:row.comments?4:0 }}>{(row.reasons||[]).join(" · ")}</div>
            {row.comments&&<div style={{ color:DIM, fontSize:11, fontStyle:"italic", fontFamily:"'Plus Jakarta Sans',sans-serif" }}>"{row.comments}"</div>}
            {row.age_days!=null&&<div style={{ color:DIM, fontSize:11, marginTop:2, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>Customer for {row.age_days} days</div>}
          </div>
        ))}
      </div>
    </div>
  );
}

// ── ATHENA FLOATING BUTTON ────────────────────────────────────────────────────
function AthenaButton({ onClick, bottom }) {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={()=>setHovered(true)}
      onMouseLeave={()=>setHovered(false)}
      title={ATHENA_NAME}
      style={{ position:"fixed", bottom:bottom, right:16, width:72, height:72, border:"none", padding:0, cursor:"pointer", background:"none", borderRadius:0, overflow:"visible", filter:hovered?"drop-shadow(0 6px 18px rgba(249,115,22,0.75))":"drop-shadow(0 4px 14px rgba(0,0,0,0.55))", transition:"filter .2s", zIndex:9050 }}>
      <img src={ATHENA_ICON} alt={ATHENA_NAME} style={{ width:"100%", height:"100%", objectFit:"contain" }} onError={e=>{e.target.style.display="none";}} />
    </button>
  );
}

// ── ATHENA CHAT PANEL ─────────────────────────────────────────────────────────
function AthenaChat({ companyId, userId, plan, onClose }) {
  const [messages,        setMessages]       = useState([]);
  const [convId,          setConvId]         = useState(null);
  const [inputVal,        setInputVal]       = useState("");
  const [loading,         setLoading]        = useState(false);
  const [loadingHistory,  setLoadingHistory] = useState(true);
  const [error,           setError]          = useState("");
  const [usageCount,      setUsageCount]     = useState(null);
  const [usageLimit,      setUsageLimit]     = useState(null);
  const messagesEndRef = useRef(null);
  const inputRef       = useRef(null);

  const PLAN_CAPS = { trial:10, starter:50, pro:200 };

  useEffect(()=>{ loadRecentConversation(); },[]);// eslint-disable-line react-hooks/exhaustive-deps
  useEffect(()=>{ messagesEndRef.current?.scrollIntoView({ behavior:"smooth" }); },[messages, loading]);

  const loadRecentConversation = async () => {
    setLoadingHistory(true);
    // Load current usage count
    const { data: prof } = await supabase.from("profiles").select("athena_messages_this_month, athena_messages_reset_date").eq("id", userId).single();
    if (prof) {
      const today = new Date();
      const rd = prof.athena_messages_reset_date ? new Date(prof.athena_messages_reset_date) : null;
      const stale = !rd || rd.getMonth()!==today.getMonth() || rd.getFullYear()!==today.getFullYear();
      setUsageCount(stale ? 0 : (prof.athena_messages_this_month||0));
    }
    // Load most recent conversation
    const { data: convs } = await supabase.from("chat_conversations").select("id").eq("user_id", userId).eq("company_id", companyId).order("created_at",{ascending:false}).limit(1);
    if (convs?.length) {
      const cid = convs[0].id;
      setConvId(cid);
      const { data: msgs } = await supabase.from("chat_messages").select("*").eq("conversation_id", cid).order("created_at",{ascending:true});
      setMessages(msgs||[]);
    }
    setLoadingHistory(false);
  };

  const startNewConversation = () => {
    setConvId(null);
    setMessages([]);
    setError("");
    setTimeout(()=>inputRef.current?.focus(), 100);
  };

  const sendMessage = async () => {
    const text = inputVal.trim();
    if (!text || loading) return;
    setInputVal("");
    setLoading(true);
    setError("");
    const tempId = "tmp-" + Date.now();
    setMessages(prev=>[...prev, { id:tempId, role:"user", content:text, created_at:new Date().toISOString() }]);
    try {
      const { data, error: fnErr } = await supabase.functions.invoke("athena-chat", {
        body: { companyId, message:text, conversationId:convId },
      });
      if (fnErr || !data?.message) {
        const d = data || {};
        if (d.error === "monthly_limit_reached") {
          setError("You've used all " + (d.limit||"") + " messages for this month. " + (plan==="business"||plan==="grandfathered"?"Contact support.":"Upgrade for more."));
        } else {
          setError("Athena couldn't respond. Please try again.");
        }
        setLoading(false);
        return;
      }
      if (!convId) setConvId(data.conversationId);
      if (data.usageCount != null) setUsageCount(data.usageCount);
      if (data.usageLimit != null) setUsageLimit(data.usageLimit);
      const assistantMsg = { id:data.messageId||("resp-"+Date.now()), role:"assistant", content:data.message, sources_cited:data.sources||[], feedback:null, created_at:new Date().toISOString() };
      setMessages(prev=>[...prev.filter(m=>m.id!==tempId), { id:tempId, role:"user", content:text, created_at:new Date().toISOString() }, assistantMsg]);
    } catch(e) { setError("Connection error. Please try again."); }
    setLoading(false);
  };

  const submitFeedback = async (msgId, vote) => {
    if (!msgId || msgId.startsWith("tmp-") || msgId.startsWith("resp-")) return;
    const newVote = messages.find(m=>m.id===msgId)?.feedback === vote ? null : vote;
    await supabase.from("chat_messages").update({ feedback:newVote }).eq("id", msgId);
    setMessages(prev=>prev.map(m=>m.id===msgId?{...m,feedback:newVote}:m));
  };

  const effectiveLimit = usageLimit !== null ? usageLimit : (PLAN_CAPS[plan] || null);
  const effectiveCount = usageCount || 0;
  const pctUsed        = effectiveLimit ? Math.min(100, (effectiveCount/effectiveLimit)*100) : 0;

  const SUGGESTIONS = [
    "What's the max span for a 2x10 floor joist at 16\" OC?",
    "How do I invite a crew member in BeamShots?",
    "What's the minimum stair riser height per IRC?",
  ];

  return (
    <div style={{ position:"fixed", inset:0, zIndex:9200, display:"flex", flexDirection:"column", justifyContent:"flex-end" }}>
      <div onClick={onClose} style={{ position:"absolute", inset:0, background:"#000a" }} />
      <div style={{ position:"relative", background:BG2, borderRadius:"18px 18px 0 0", width:"100%", maxWidth:480, margin:"0 auto", height:"82vh", display:"flex", flexDirection:"column", animation:"slideUp .3s ease", boxShadow:"0 -8px 40px #000a" }}>

        {/* Header */}
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"16px 16px 12px", borderBottom:"1px solid " + BG4, flexShrink:0 }}>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <img src={ATHENA_ICON} alt={ATHENA_NAME} style={{ width:36, height:36, borderRadius:"50%", objectFit:"cover", border:"2px solid " + OR }} onError={e=>{e.target.style.display="none";}} />
            <div>
              <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:20, color:TEXT, letterSpacing:2 }}>{ATHENA_NAME.toUpperCase()}</div>
              <div style={{ color:MUTED, fontSize:10, fontFamily:"'Plus Jakarta Sans',sans-serif", letterSpacing:1 }}>AI CONSTRUCTION ASSISTANT</div>
            </div>
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
            <button onClick={startNewConversation} style={{ background:BG3, border:"1px solid " + BG4, color:MUTED, borderRadius:7, padding:"5px 10px", fontFamily:"'Bebas Neue',sans-serif", fontSize:11, letterSpacing:1, cursor:"pointer" }}>NEW CHAT</button>
            <button onClick={onClose} style={{ background:"none", border:"none", color:MUTED, fontSize:20, cursor:"pointer" }}>✕</button>
          </div>
        </div>

        {/* Usage bar */}
        {effectiveLimit && (
          <div style={{ padding:"6px 16px 8px", background:BG3, borderBottom:"1px solid " + BG4, flexShrink:0 }}>
            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
              <span style={{ color:DIM, fontSize:10, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>{effectiveCount} / {effectiveLimit} messages this month</span>
              {effectiveCount >= effectiveLimit * 0.8 && <span style={{ color:OR, fontSize:10, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>⚠️ Approaching limit</span>}
            </div>
            <div style={{ height:3, background:BG4, borderRadius:2 }}>
              <div style={{ height:"100%", width:pctUsed+"%", background:pctUsed>=100?"#ef4444":OR, borderRadius:2, transition:"width .4s" }} />
            </div>
          </div>
        )}

        {/* Messages */}
        <div style={{ flex:1, overflowY:"auto", padding:"14px 12px", display:"flex", flexDirection:"column", gap:14 }}>
          {loadingHistory && <div style={{ textAlign:"center", padding:"32px 0" }}><div style={{ width:24, height:24, border:"2px solid " + OR, borderTopColor:"transparent", borderRadius:"50%", animation:"spin .7s linear infinite", margin:"0 auto" }} /></div>}

          {!loadingHistory && messages.length===0 && (
            <div style={{ textAlign:"center", padding:"28px 12px", animation:"fadeIn .3s ease" }}>
              <img src={ATHENA_ICON} alt={ATHENA_NAME} style={{ width:70, height:70, borderRadius:"50%", objectFit:"cover", margin:"0 auto 14px", display:"block", border:"2px solid " + OR, opacity:0.85 }} onError={e=>{e.target.style.display="none";}} />
              <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:20, color:TEXT, letterSpacing:2, marginBottom:6 }}>ASK {ATHENA_NAME.toUpperCase()} ANYTHING</div>
              <div style={{ color:MUTED, fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif", lineHeight:1.65, marginBottom:18 }}>Building codes, structural math, material specs, and BeamShots help.</div>
              <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
                {SUGGESTIONS.map(q=>(
                  <button key={q} onClick={()=>{ setInputVal(q); inputRef.current?.focus(); }} style={{ background:BG3, border:"1px solid " + BG4, color:MUTED, borderRadius:9, padding:"9px 12px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:12, cursor:"pointer", textAlign:"left", lineHeight:1.45 }}>{q}</button>
                ))}
              </div>
            </div>
          )}

          {messages.map(msg=>(
            <div key={msg.id} style={{ display:"flex", gap:8, alignItems:"flex-start", flexDirection:msg.role==="user"?"row-reverse":"row" }}>
              {msg.role==="assistant" && <img src={ATHENA_ICON} alt={ATHENA_NAME} style={{ width:28, height:28, borderRadius:"50%", objectFit:"cover", border:"1px solid " + OR, flexShrink:0, marginTop:2 }} onError={e=>{e.target.style.display="none";}} />}
              <div style={{ maxWidth:"82%", display:"flex", flexDirection:"column", gap:5 }}>
                <div style={{ background:msg.role==="user"?"linear-gradient(135deg," + OR + "," + ORD + ")":BG3, color:msg.role==="user"?"#fff":TEXT, borderRadius:msg.role==="user"?"14px 14px 4px 14px":"14px 14px 14px 4px", padding:"10px 14px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:13, lineHeight:1.7, border:msg.role==="assistant"?"1px solid " + BG4:"none", whiteSpace:"pre-wrap", wordBreak:"break-word" }}>
                  {msg.content}
                </div>
                {msg.role==="assistant" && msg.sources_cited?.length>0 && (
                  <div style={{ display:"flex", flexDirection:"column", gap:3, paddingLeft:4 }}>
                    {msg.sources_cited.map((url,i)=>(
                      <a key={i} href={url} target="_blank" rel="noopener noreferrer" style={{ color:ORL, fontSize:10, fontFamily:"'Plus Jakarta Sans',sans-serif", wordBreak:"break-all", opacity:0.8, textDecoration:"none" }}>🔗 {url}</a>
                    ))}
                  </div>
                )}
                {msg.role==="assistant" && !msg.id?.startsWith("resp-") && (
                  <div style={{ display:"flex", gap:4 }}>
                    <button onClick={()=>submitFeedback(msg.id,"up")} style={{ background:msg.feedback==="up"?"#142010":"none", border:"1px solid " + (msg.feedback==="up"?"#4ade80":BG4), color:msg.feedback==="up"?"#4ade80":DIM, borderRadius:6, padding:"3px 9px", fontSize:12, cursor:"pointer" }}>👍</button>
                    <button onClick={()=>submitFeedback(msg.id,"down")} style={{ background:msg.feedback==="down"?"#2a0a0a":"none", border:"1px solid " + (msg.feedback==="down"?"#ef4444":BG4), color:msg.feedback==="down"?"#ef4444":DIM, borderRadius:6, padding:"3px 9px", fontSize:12, cursor:"pointer" }}>👎</button>
                  </div>
                )}
              </div>
            </div>
          ))}

          {loading && (
            <div style={{ display:"flex", gap:8, alignItems:"flex-start" }}>
              <img src={ATHENA_ICON} alt={ATHENA_NAME} style={{ width:28, height:28, borderRadius:"50%", objectFit:"cover", border:"1px solid " + OR, flexShrink:0 }} onError={e=>{e.target.style.display="none";}} />
              <div style={{ background:BG3, border:"1px solid " + BG4, borderRadius:"14px 14px 14px 4px", padding:"12px 16px", display:"flex", gap:5, alignItems:"center" }}>
                {[0,1,2].map(i=><div key={i} style={{ width:7, height:7, borderRadius:"50%", background:OR, animation:"pulse .9s ease-in-out " + (i*0.18) + "s infinite" }} />)}
              </div>
            </div>
          )}

          {error && <div style={{ color:"#ef4444", fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif", textAlign:"center", padding:"8px 12px", background:"#2a0a0a", border:"1px solid #ef444430", borderRadius:8 }}>{error}</div>}
          <div ref={messagesEndRef} />
        </div>

        {/* Input */}
        <div style={{ padding:"10px 12px 20px", borderTop:"1px solid " + BG4, flexShrink:0 }}>
          <div style={{ display:"flex", gap:8, alignItems:"flex-end" }}>
            <textarea
              ref={inputRef}
              value={inputVal}
              onChange={e=>setInputVal(e.target.value)}
              onKeyDown={e=>{ if(e.key==="Enter"&&!e.shiftKey){ e.preventDefault(); sendMessage(); } }}
              placeholder="Ask about codes, calculations, BeamShots..."
              rows={2}
              disabled={loading}
              style={{ flex:1, background:BG3, border:"1px solid " + BG4, color:TEXT, borderRadius:12, padding:"10px 14px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:13, resize:"none", outline:"none", lineHeight:1.55 }}
            />
            <button
              onClick={sendMessage}
              disabled={loading||!inputVal.trim()}
              style={{ background:"linear-gradient(135deg," + OR + "," + ORD + ")", color:"#fff", border:"none", borderRadius:12, padding:"12px 14px", cursor:loading||!inputVal.trim()?"not-allowed":"pointer", opacity:loading||!inputVal.trim()?0.45:1, flexShrink:0 }}
            >
              <span style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:14, letterSpacing:1 }}>SEND</span>
            </button>
          </div>
          <div style={{ color:DIM, fontSize:10, fontFamily:"'Plus Jakarta Sans',sans-serif", marginTop:6, textAlign:"center" }}>Shift+Enter for new line · Always verify codes with local AHJ</div>
        </div>
      </div>
    </div>
  );
}

// ── BRANDING SETTINGS ─────────────────────────────────────────────────────────
function BrandingSettings({ companyId, branding, plan, onBrandingUpdate, onGoToPlans, staleThreshold, staleAlertsEnabled, onStaleUpdate, cancelAtPeriodEnd, currentPeriodEnd, onCancelSubscription, onReactivateSubscription, onOpenPortal, customCategories, onSaveCustomCategories }) {
  const [primaryColor,   setPrimaryColor]   = useState(branding.primaryColor);
  const [secondaryColor, setSecondaryColor] = useState(branding.secondaryColor);
  const [logoPreview,    setLogoPreview]    = useState(branding.logoUrl || null);
  const [logoFile,       setLogoFile]       = useState(null);
  const [croppedBlob,    setCroppedBlob]    = useState(null);
  const [showCropModal,  setShowCropModal]  = useState(false);
  const [logoSize,       setLogoSize]       = useState(branding.logoSize || "medium");
  const [taglineVal,     setTaglineVal]     = useState(branding.tagline || "");
  const [staleThreshVal, setStaleThreshVal] = useState(staleThreshold !== undefined ? staleThreshold : 2);
  const [staleAlertsVal, setStaleAlertsVal] = useState(staleAlertsEnabled !== undefined ? staleAlertsEnabled : true);
  const [saving,         setSaving]         = useState(false);
  const [msg,            setMsg]            = useState("");
  const [showCancelModal,setShowCancelModal]= useState(false);
  const [cancelStep,     setCancelStep]     = useState(1);
  const [cancelReasons,  setCancelReasons]  = useState([]);
  const [cancelOtherText,setCancelOtherText]= useState("");
  const [cancelBusy,     setCancelBusy]     = useState(false);
  const [cancelAccessUntil,setCancelAccessUntil] = useState(null);
  const [cancelDone,     setCancelDone]     = useState(false);
  const [cancelError,    setCancelError]    = useState("");
  const [reactivateBusy, setReactivateBusy] = useState(false);
  const [portalBusy,     setPortalBusy]     = useState(false);
  const [primaryTrade,   setPrimaryTrade]   = useState(branding.primaryTrade   || "");
  const [primaryRegion,  setPrimaryRegion]  = useState(branding.primaryRegion  || "");
  const [specialtiesVal, setSpecialtiesVal] = useState((branding.companySpecialties||[]).join(", "));
  const [athenaEnabled,  setAthenaEnabled]  = useState(branding.athenaEnabled  !== false);
  const [localCats,      setLocalCats]      = useState(customCategories||[]);
  const [newCatInput,    setNewCatInput]    = useState("");
  const [catSaving,      setCatSaving]      = useState(false);
  const [catMsg,         setCatMsg]         = useState("");
  const fileRef = useRef();

  const handleLogoSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setLogoFile(file);
    setShowCropModal(true);
  };

  const handleCropConfirm = (blob) => {
    setCroppedBlob(blob);
    setShowCropModal(false);
    const previewUrl = URL.createObjectURL(blob);
    const img = new Image();
    img.onload = () => {
      const colors = extractColors(img);
      setPrimaryColor(colors.primary);
      setSecondaryColor(colors.secondary);
      URL.revokeObjectURL(previewUrl);
      setLogoPreview(URL.createObjectURL(blob));
    };
    img.src = previewUrl;
  };

  const handleCropCancel = () => {
    setLogoFile(null);
    setShowCropModal(false);
    if (fileRef.current) fileRef.current.value = "";
  };

  const handleSave = async () => {
    setSaving(true); setMsg("");
    try {
      let logoUrl = branding.logoUrl || null;
      if (croppedBlob || logoFile) {
        let safeExt = "png";
        let contentType = "image/png";
        if (!croppedBlob && logoFile) {
          const ext = logoFile.name.split(".").pop().toLowerCase();
          safeExt = ["jpg","jpeg","png","gif","webp"].includes(ext) ? ext : "png";
          contentType = logoFile.type || "image/png";
        }
        const uploadFile = croppedBlob || logoFile;
        const path = companyId + "/logo." + safeExt;
        const { error: upErr } = await supabase.storage.from("logos").upload(path, uploadFile, { upsert: true, contentType });
        if (upErr) { setMsg("Logo upload failed: " + upErr.message); setSaving(false); return; }
        const { data: urlData } = supabase.storage.from("logos").getPublicUrl(path);
        logoUrl = urlData?.publicUrl || null;
      }
      const tagline          = taglineVal.trim() || null;
      const companySpecialties = specialtiesVal ? specialtiesVal.split(",").map(s=>s.trim()).filter(Boolean) : [];
      const { error: dbErr } = await supabase.from("companies").update({
        logo_url:             logoUrl,
        primary_color:        primaryColor,
        secondary_color:      secondaryColor,
        tagline,
        stale_threshold_days: staleThreshVal,
        stale_alerts_enabled: staleAlertsVal,
        logo_size:            logoSize,
        primary_trade:        primaryTrade.trim() || null,
        primary_region:       primaryRegion.trim() || null,
        company_specialties:  companySpecialties,
        athena_enabled:       athenaEnabled,
      }).eq("id", companyId);
      if (dbErr) { setMsg("Save failed: " + dbErr.message); setSaving(false); return; }
      onBrandingUpdate({ logoUrl, primaryColor, secondaryColor, tagline, logoSize, subdomain: branding.subdomain, primaryTrade: primaryTrade.trim()||"", primaryRegion: primaryRegion.trim()||"", companySpecialties, athenaEnabled });
      onStaleUpdate(staleThreshVal, staleAlertsVal);
      setMsg("✓ Settings saved!");
    } catch (e) {
      setMsg("Unexpected error: " + e.message);
    }
    setSaving(false);
  };

  const label = { color:MUTED, fontSize:11, letterSpacing:2, display:"block", marginBottom:6 };
  const previewLogoH = LOGO_HEIGHTS[logoSize] || 42;

  return (
    <div style={{ padding:"24px 16px 80px", animation:"fadeIn .25s ease" }}>
      <h2 style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:28, color:TEXT, letterSpacing:2, marginBottom:4 }}>COMPANY BRANDING</h2>
      <div style={{ width:40, height:3, background:"linear-gradient(90deg," + ORD + "," + ORL + ")", borderRadius:2, marginBottom:8 }} />
      <p style={{ color:MUTED, fontSize:13, lineHeight:1.6, marginBottom:24, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>Upload your logo and set your brand colors. The app will update its theme to match your company identity.</p>

      {/* MANAGE SUBSCRIPTION — paid plans only */}
      {onCancelSubscription && (plan==="starter"||plan==="pro"||plan==="business"||plan==="grandfathered") && (
        <div style={{ background:BG2, border:"1px solid " + (cancelAtPeriodEnd?"#ef444440":BG4), borderRadius:14, padding:"20px", marginBottom:16 }}>
          <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:14, color:cancelAtPeriodEnd?"#f87171":OR, letterSpacing:3, marginBottom:8 }}>MANAGE SUBSCRIPTION</div>
          <div style={{ color:MUTED, fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:14, lineHeight:1.6 }}>
            {"Plan: "}
            <span style={{ color:TEXT, fontWeight:600 }}>{plan.charAt(0).toUpperCase()+plan.slice(1)}</span>
            {currentPeriodEnd && !cancelAtPeriodEnd && (
              <>{" · Next charge: "}<span style={{ color:TEXT, fontWeight:600 }}>{new Date(currentPeriodEnd).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"})}</span></>
            )}
          </div>
          {cancelAtPeriodEnd ? (
            <>
              <div style={{ background:"#2a0a0a", border:"1px solid #ef444440", borderRadius:10, padding:"12px 14px", marginBottom:14 }}>
                <div style={{ color:"#f87171", fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif", lineHeight:1.6 }}>
                  {"Your subscription is set to cancel. You'll keep full access until "}
                  <strong>{currentPeriodEnd ? new Date(currentPeriodEnd).toLocaleDateString("en-US",{month:"long",day:"numeric",year:"numeric"}) : "the end of your billing period"}</strong>
                  {"."}
                </div>
              </div>
              <button
                onClick={()=>{ setReactivateBusy(true); setCancelError(""); onReactivateSubscription(()=>{ setReactivateBusy(false); setMsg("✓ Subscription reactivated!"); }, (e)=>{ setReactivateBusy(false); setCancelError(e); }); }}
                disabled={reactivateBusy}
                style={{ width:"100%", background:"linear-gradient(135deg,#276627,#142010)", color:"#4ade80", border:"1px solid #4ade8040", borderRadius:10, padding:"13px", fontFamily:"'Bebas Neue',sans-serif", fontSize:16, letterSpacing:2, cursor:reactivateBusy?"not-allowed":"pointer", opacity:reactivateBusy?0.7:1 }}
              >
                {reactivateBusy ? "REACTIVATING..." : "REACTIVATE SUBSCRIPTION"}
              </button>
              {cancelError && <div style={{ color:"#ef4444", fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif", marginTop:8 }}>{cancelError}</div>}
            </>
          ) : (
            <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
              <button
                onClick={()=>{ setPortalBusy(true); onOpenPortal(()=>setPortalBusy(false)); }}
                disabled={portalBusy}
                style={{ width:"100%", background:BG3, color:TEXT, border:"1px solid " + BG4, borderRadius:10, padding:"12px", fontFamily:"'Bebas Neue',sans-serif", fontSize:14, letterSpacing:2, cursor:portalBusy?"not-allowed":"pointer", opacity:portalBusy?0.7:1 }}
              >
                {portalBusy ? "OPENING..." : "UPDATE PAYMENT METHOD"}
              </button>
              <button
                onClick={onGoToPlans}
                style={{ width:"100%", background:BG3, color:TEXT, border:"1px solid " + BG4, borderRadius:10, padding:"12px", fontFamily:"'Bebas Neue',sans-serif", fontSize:14, letterSpacing:2, cursor:"pointer" }}
              >
                CHANGE PLAN
              </button>
              <button
                onClick={()=>{ setShowCancelModal(true); setCancelStep(1); setCancelReasons([]); setCancelOtherText(""); setCancelDone(false); setCancelError(""); }}
                style={{ width:"100%", background:"none", color:"#ef4444", border:"1px solid #3a1a1a", borderRadius:10, padding:"12px", fontFamily:"'Bebas Neue',sans-serif", fontSize:14, letterSpacing:2, cursor:"pointer" }}
              >
                CANCEL SUBSCRIPTION
              </button>
            </div>
          )}
        </div>
      )}

      {/* Crew subdomain link — Business only */}
      {(plan==="business"||plan==="grandfathered") && branding.subdomain && (
        <div style={{ background:"linear-gradient(135deg,#1a2a1a," + BG2 + ")", border:"1px solid #4ade8040", borderRadius:14, padding:"20px", marginBottom:16 }}>
          <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:14, color:"#4ade80", letterSpacing:3, marginBottom:6 }}>YOUR CREW LINK</div>
          <div style={{ color:MUTED, fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:12, lineHeight:1.6 }}>Share with your crew. When they add it to their home screen they'll see your company logo as the icon.</div>
          <div style={{ background:BG3, border:"1px solid " + BG4, borderRadius:10, padding:"12px 14px", marginBottom:10, wordBreak:"break-all", color:"#4ade80", fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif", fontWeight:600 }}>
            {"https://" + branding.subdomain + ".beamshots.io"}
          </div>
          <button
            onClick={() => { navigator.clipboard.writeText("https://" + branding.subdomain + ".beamshots.io"); setMsg("✓ Link copied!"); }}
            style={{ width:"100%", background:"linear-gradient(135deg,#276627,#142010)", color:"#4ade80", border:"1px solid #4ade8040", borderRadius:9, padding:"10px", fontFamily:"'Bebas Neue',sans-serif", fontSize:14, letterSpacing:2, cursor:"pointer" }}
          >
            COPY LINK
          </button>
        </div>
      )}

      {/* Logo upload */}
      {(plan==="business"||plan==="grandfathered") ? (
        <div style={{ background:BG2, border:"1px solid " + BG4, borderRadius:14, padding:"20px", marginBottom:16 }}>
          <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:14, color:OR, letterSpacing:3, marginBottom:16 }}>COMPANY LOGO</div>
          <div style={{ display:"flex", alignItems:"center", gap:16, marginBottom:16 }}>
            <div style={{ width:80, height:80, borderRadius:12, background:BG3, border:"2px dashed " + BG4, display:"flex", alignItems:"center", justifyContent:"center", overflow:"hidden", flexShrink:0 }}>
              {logoPreview
                ? <img src={logoPreview} alt="Logo preview" style={{ width:"100%", height:"100%", objectFit:"contain" }} />
                : <span style={{ fontSize:28 }}>🏢</span>
              }
            </div>
            <div>
              <div style={{ color:TEXT, fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif", fontWeight:600, marginBottom:4 }}>{logoPreview ? "Logo ready" : "No logo yet"}</div>
              <div style={{ color:MUTED, fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:10 }}>PNG or JPG. You'll crop it after selecting.</div>
              <button onClick={() => fileRef.current.click()} style={{ background:"linear-gradient(135deg," + OR + "," + ORD + ")", color:"#fff", border:"none", borderRadius:8, padding:"8px 16px", fontFamily:"'Bebas Neue',sans-serif", fontSize:13, letterSpacing:1, cursor:"pointer" }}>
                {logoPreview ? "CHANGE LOGO" : "UPLOAD LOGO"}
              </button>
              <input ref={fileRef} type="file" accept="image/*" style={{ display:"none" }} onChange={handleLogoSelect} />
            </div>
          </div>
          {logoPreview && (
            <div style={{ background:BG3, border:"1px solid " + BG4, borderRadius:10, padding:"12px 14px" }}>
              <div style={{ color:MUTED, fontSize:11, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
                Colors auto-extracted from your cropped logo. Adjust below if needed.
              </div>
            </div>
          )}
        </div>
      ) : (
        <div style={{ background:BG2, border:"1px solid " + BG4, borderRadius:14, padding:"20px", marginBottom:16, opacity:0.7 }}>
          <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:14, color:MUTED, letterSpacing:3, marginBottom:10 }}>COMPANY LOGO</div>
          <div onClick={onGoToPlans} style={{ display:"flex", alignItems:"center", gap:12, background:BG3, border:"1px solid " + BG4, borderRadius:10, padding:"14px", cursor:"pointer" }}>
            <span style={{ fontSize:22 }}>🔒</span>
            <div>
              <div style={{ color:TEXT, fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif", fontWeight:600, marginBottom:2 }}>Business plan required</div>
              <div style={{ color:MUTED, fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>Tap to upgrade to Business ($99/mo) and enable white-label branding.</div>
            </div>
            <span style={{ color:OR, fontSize:16, marginLeft:"auto" }}>›</span>
          </div>
        </div>
      )}

      {/* Logo size + header preview — Business with logo only */}
      {(plan==="business"||plan==="grandfathered") && logoPreview && (
        <div style={{ background:BG2, border:"1px solid " + BG4, borderRadius:14, padding:"20px", marginBottom:16 }}>
          <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:14, color:OR, letterSpacing:3, marginBottom:12 }}>LOGO SIZE IN HEADER</div>
          <div style={{ display:"flex", gap:8, marginBottom:16 }}>
            {["small","medium","large"].map(sz => (
              <button key={sz} onClick={() => setLogoSize(sz)}
                style={{ flex:1, background:logoSize===sz?"linear-gradient(135deg," + OR + "," + ORD + ")":BG3, color:logoSize===sz?"#fff":MUTED, border:"1px solid " + (logoSize===sz?OR:BG4), borderRadius:9, padding:"10px 0", fontFamily:"'Bebas Neue',sans-serif", fontSize:14, letterSpacing:2, cursor:"pointer" }}>
                {sz==="small"?"S":sz==="medium"?"M":"L"}
              </button>
            ))}
          </div>
          <div style={{ color:MUTED, fontSize:11, letterSpacing:2, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:8 }}>HEADER PREVIEW</div>
          <div style={{ background:"linear-gradient(160deg,#1a1c22 0%,#181a1f 100%)", border:"1px solid " + BG4, borderRadius:10, padding:"0 12px", height:76, display:"flex", alignItems:"center" }}>
            <img src={logoPreview} alt="Logo" style={{ height:previewLogoH, maxWidth:130, objectFit:"contain" }} />
          </div>
        </div>
      )}

      {/* Color pickers */}
      <div style={{ background:BG2, border:"1px solid " + BG4, borderRadius:14, padding:"20px", marginBottom:16 }}>
        <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:14, color:OR, letterSpacing:3, marginBottom:16 }}>BRAND COLORS</div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16 }}>
          <div>
            <label style={label}>PRIMARY COLOR</label>
            <div style={{ display:"flex", alignItems:"center", gap:10, background:BG3, border:"1px solid " + BG4, borderRadius:9, padding:"8px 12px", marginBottom:8 }}>
              <input type="color" value={primaryColor} onChange={e=>setPrimaryColor(e.target.value)} style={{ width:36, height:36, border:"none", background:"none", cursor:"pointer", borderRadius:6, padding:0 }} />
              <span style={{ color:TEXT, fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif", fontWeight:600 }}>{primaryColor}</span>
            </div>
          </div>
          <div>
            <label style={label}>SECONDARY COLOR</label>
            <div style={{ display:"flex", alignItems:"center", gap:10, background:BG3, border:"1px solid " + BG4, borderRadius:9, padding:"8px 12px", marginBottom:8 }}>
              <input type="color" value={secondaryColor} onChange={e=>setSecondaryColor(e.target.value)} style={{ width:36, height:36, border:"none", background:"none", cursor:"pointer", borderRadius:6, padding:0 }} />
              <span style={{ color:TEXT, fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif", fontWeight:600 }}>{secondaryColor}</span>
            </div>
          </div>
        </div>
        <div style={{ marginTop:8 }}>
          <label style={label}>PREVIEW</label>
          <div style={{ display:"flex", gap:8, alignItems:"center" }}>
            <div style={{ flex:1, height:36, borderRadius:8, background:"linear-gradient(135deg," + primaryColor + "," + hexAdjust(primaryColor,-50) + ")", display:"flex", alignItems:"center", justifyContent:"center" }}>
              <span style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:13, color:"#fff", letterSpacing:2 }}>PRIMARY BTN</span>
            </div>
            <div style={{ width:36, height:36, borderRadius:8, background:secondaryColor }} />
            <div style={{ width:36, height:36, borderRadius:8, background:hexAdjust(primaryColor,-50) }} />
          </div>
        </div>
      </div>

      <button onClick={()=>{ setPrimaryColor("#f97316"); setSecondaryColor("#f59e0b"); }} style={{ width:"100%", background:"none", border:"1px solid " + BG4, color:MUTED, borderRadius:10, padding:"11px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:13, cursor:"pointer", marginBottom:16 }}>
        Reset to BeamShots defaults
      </button>

      {/* Custom tagline — Pro / Business / Grandfathered */}
      <div style={{ background:BG2, border:"1px solid " + BG4, borderRadius:14, padding:"20px", marginBottom:16 }}>
        <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:14, color:OR, letterSpacing:3, marginBottom:6 }}>CUSTOM TAGLINE</div>
        {(plan==="pro"||plan==="business"||plan==="grandfathered") ? (
          <>
            <div style={{ color:MUTED, fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:10 }}>Shown beneath the header on your app. Leave blank for the BeamShots default.</div>
            <textarea
              value={taglineVal}
              onChange={e=>setTaglineVal(e.target.value)}
              placeholder={DEFAULT_TAGLINE}
              rows={2}
              style={{ width:"100%", background:BG3, border:"1px solid " + BG4, color:TEXT, borderRadius:9, padding:"10px 12px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:13, resize:"vertical", outline:"none", lineHeight:1.6 }}
            />
          </>
        ) : (
          <div onClick={onGoToPlans} style={{ display:"flex", alignItems:"center", gap:10, background:BG3, border:"1px solid " + BG4, borderRadius:10, padding:"12px 14px", cursor:"pointer" }}>
            <span style={{ fontSize:18 }}>🔒</span>
            <div style={{ color:MUTED, fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>Pro or Business plan required to set a custom tagline.</div>
            <span style={{ color:OR, fontSize:16, marginLeft:"auto" }}>›</span>
          </div>
        )}
      </div>

      {/* Athena AI Assistant settings */}
      <div style={{ background:BG2, border:"1px solid " + BG4, borderRadius:14, padding:"20px", marginBottom:16 }}>
        <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:14, color:OR, letterSpacing:3, marginBottom:6 }}>ATHENA AI ASSISTANT</div>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:18 }}>
          <div>
            <div style={{ color:TEXT, fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif", fontWeight:600, marginBottom:2 }}>Enable Athena for your company</div>
            <div style={{ color:MUTED, fontSize:11, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>Building codes, structural math, and app support</div>
          </div>
          <button
            onClick={()=>setAthenaEnabled(v=>!v)}
            style={{ width:48, height:26, borderRadius:13, border:"none", cursor:"pointer", background:athenaEnabled?"#4ade80":"#475569", position:"relative", transition:"background .2s", flexShrink:0 }}
          >
            <span style={{ position:"absolute", top:3, left:athenaEnabled?24:3, width:20, height:20, borderRadius:"50%", background:"#fff", transition:"left .2s", display:"block" }} />
          </button>
        </div>
        <label style={label}>PRIMARY TRADE</label>
        <input
          value={primaryTrade}
          onChange={e=>setPrimaryTrade(e.target.value)}
          placeholder="e.g. General Contractor, Framing, Electrical..."
          style={{ width:"100%", background:BG3, border:"1px solid " + BG4, color:TEXT, borderRadius:9, padding:"10px 12px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:13, outline:"none", marginBottom:12 }}
        />
        <label style={label}>REGION / STATE</label>
        <input
          value={primaryRegion}
          onChange={e=>setPrimaryRegion(e.target.value)}
          placeholder="e.g. Texas, Pacific Northwest, Ontario..."
          style={{ width:"100%", background:BG3, border:"1px solid " + BG4, color:TEXT, borderRadius:9, padding:"10px 12px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:13, outline:"none", marginBottom:12 }}
        />
        <label style={label}>SPECIALTIES (COMMA SEPARATED)</label>
        <input
          value={specialtiesVal}
          onChange={e=>setSpecialtiesVal(e.target.value)}
          placeholder="e.g. Deck building, ADUs, Custom homes..."
          style={{ width:"100%", background:BG3, border:"1px solid " + BG4, color:TEXT, borderRadius:9, padding:"10px 12px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:13, outline:"none" }}
        />
        <div style={{ color:DIM, fontSize:11, fontFamily:"'Plus Jakarta Sans',sans-serif", marginTop:6, lineHeight:1.5 }}>Athena uses your trade and region to tailor answers. Saved with your settings below.</div>
      </div>

      {/* Custom Categories — Business / Grandfathered only */}
      {onSaveCustomCategories && (plan==="business"||plan==="grandfathered") && (
        <div style={{ background:BG2, border:"1px solid " + BG4, borderRadius:14, padding:"20px", marginBottom:16 }}>
          <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:14, color:OR, letterSpacing:3, marginBottom:6 }}>CUSTOM CATEGORIES</div>
          <div style={{ color:MUTED, fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:14, lineHeight:1.6 }}>Add your own photo categories (max 10). They appear alongside the built-in ones.</div>
          <div style={{ display:"flex", flexDirection:"column", gap:6, marginBottom:12 }}>
            {localCats.map((cat, i) => (
              <div key={cat} style={{ display:"flex", alignItems:"center", gap:8, background:BG3, border:"1px solid " + BG4, borderRadius:8, padding:"8px 12px" }}>
                <span style={{ color:TEXT, fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif", flex:1 }}>{cat}</span>
                <button onClick={()=>setLocalCats(prev=>prev.filter((_,j)=>j!==i))} style={{ background:"none", border:"none", color:"#ef4444", fontSize:15, cursor:"pointer", padding:"0 4px", lineHeight:1 }}>✕</button>
              </div>
            ))}
            {localCats.length===0&&<div style={{ color:DIM, fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif", textAlign:"center", padding:"8px 0" }}>No custom categories yet</div>}
          </div>
          {localCats.length < 10 && (
            <div style={{ display:"flex", gap:8, marginBottom:12 }}>
              <input
                value={newCatInput}
                onChange={e=>setNewCatInput(e.target.value.slice(0,30))}
                onKeyDown={e=>{ if(e.key==="Enter"){ const n=newCatInput.trim(); if(n&&!CATEGORIES.includes(n)&&!localCats.includes(n)) setLocalCats(prev=>[...prev,n]); setNewCatInput(""); } }}
                placeholder="Category name (max 30 chars)..."
                style={{ flex:1, background:BG3, border:"1px solid " + BG4, color:TEXT, borderRadius:9, padding:"10px 12px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:13, outline:"none" }}
              />
              <button
                onClick={()=>{ const n=newCatInput.trim(); if(n&&!CATEGORIES.includes(n)&&!localCats.includes(n)) setLocalCats(prev=>[...prev,n]); setNewCatInput(""); }}
                style={{ background:"linear-gradient(135deg," + OR + "," + ORD + ")", color:"#fff", border:"none", borderRadius:9, padding:"10px 16px", fontFamily:"'Bebas Neue',sans-serif", fontSize:14, letterSpacing:1, cursor:"pointer" }}
              >ADD</button>
            </div>
          )}
          {catMsg&&<div style={{ background:catMsg.startsWith("✓")?"#0a2a0a":"#2a0a0a", border:"1px solid " + (catMsg.startsWith("✓")?"#4ade8060":"#ef444460"), color:catMsg.startsWith("✓")?"#4ade80":"#ef4444", fontSize:13, padding:"8px 12px", borderRadius:7, marginBottom:10, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>{catMsg}</div>}
          <button
            onClick={()=>{ setCatSaving(true); setCatMsg(""); onSaveCustomCategories(localCats, ()=>{ setCatSaving(false); setCatMsg("✓ Categories saved!"); }, (e)=>{ setCatSaving(false); setCatMsg("Save failed: " + e); }); }}
            disabled={catSaving}
            style={{ width:"100%", background:"linear-gradient(135deg," + OR + "," + ORD + ")", color:"#fff", border:"none", borderRadius:10, padding:"11px", fontFamily:"'Bebas Neue',sans-serif", fontSize:15, letterSpacing:2, cursor:catSaving?"not-allowed":"pointer", opacity:catSaving?0.7:1 }}
          >{catSaving?"SAVING...":"SAVE CATEGORIES"}</button>
        </div>
      )}

      {/* Job alerts */}
      <div style={{ background:BG2, border:"1px solid " + BG4, borderRadius:14, padding:"20px", marginBottom:16 }}>
        <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:14, color:OR, letterSpacing:3, marginBottom:6 }}>JOB ALERTS</div>
        <div style={{ color:MUTED, fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:14 }}>Jobs with no new photos for this many days are flagged as stale.</div>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16 }}>
          <label style={{ color:TEXT, fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif", fontWeight:600 }}>Stale alerts enabled</label>
          <button
            onClick={()=>setStaleAlertsVal(v=>!v)}
            style={{ width:48, height:26, borderRadius:13, border:"none", cursor:"pointer", background:staleAlertsVal?"#4ade80":"#475569", position:"relative", transition:"background .2s", flexShrink:0 }}
          >
            <span style={{ position:"absolute", top:3, left:staleAlertsVal?24:3, width:20, height:20, borderRadius:"50%", background:"#fff", transition:"left .2s", display:"block" }} />
          </button>
        </div>
        <label style={label}>DAYS BEFORE STALE</label>
        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
          <input
            type="number" min={1} max={30} value={staleThreshVal}
            onChange={e=>setStaleThreshVal(Math.max(1,parseInt(e.target.value)||1))}
            style={{ width:80, background:BG3, border:"1px solid " + BG4, color:TEXT, borderRadius:9, padding:"10px 12px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:14, outline:"none" }}
          />
          <span style={{ color:MUTED, fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>days without photos = stale</span>
        </div>
      </div>

      {msg && <div style={{ background:msg.startsWith("✓")?"#0a2a0a":"#2a0a0a", border:"1px solid " + (msg.startsWith("✓")?"#4ade8060":"#ef444460"), color:msg.startsWith("✓")?"#4ade80":"#ef4444", fontSize:13, padding:"10px 14px", borderRadius:8, marginBottom:14, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>{msg}</div>}

      <button onClick={handleSave} disabled={saving} style={{ width:"100%", background:"linear-gradient(135deg," + OR + "," + ORD + ")", color:"#fff", border:"none", borderRadius:10, padding:"14px", fontFamily:"'Bebas Neue',sans-serif", fontSize:18, letterSpacing:2, cursor:"pointer", boxShadow:"0 4px 20px var(--brand-or-25)", opacity:saving?0.7:1 }}>
        {saving ? "SAVING..." : "SAVE SETTINGS"}
      </button>

      {showCropModal && logoFile && (
        <LogoCropModal file={logoFile} onConfirm={handleCropConfirm} onCancel={handleCropCancel} />
      )}

      {/* CANCEL SUBSCRIPTION MODAL */}
      {showCancelModal && (
        <div style={{ position:"fixed", inset:0, background:"#000d", zIndex:9100, display:"flex", alignItems:"flex-end", justifyContent:"center" }}>
          <div onClick={e=>e.stopPropagation()} style={{ background:BG2, border:"1px solid " + BG4, borderRadius:"18px 18px 0 0", width:"100%", maxWidth:480, padding:"28px 22px 40px", animation:"slideUp .25s ease", maxHeight:"85vh", overflowY:"auto" }}>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16 }}>
              <span style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:20, color:"#f87171", letterSpacing:2 }}>
                {cancelDone ? "SUBSCRIPTION CANCELED" : cancelStep===1 ? "WHY ARE YOU LEAVING?" : "CONFIRM CANCELLATION"}
              </span>
              {!cancelBusy && <button onClick={()=>{ setShowCancelModal(false); setCancelStep(1); setCancelDone(false); setCancelError(""); }} style={{ background:"none", border:"none", color:MUTED, fontSize:20, cursor:"pointer" }}>✕</button>}
            </div>

            {/* Step 1 — Reason questionnaire */}
            {!cancelDone && cancelStep===1 && (
              <>
                <p style={{ color:MUTED, fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif", lineHeight:1.6, marginBottom:16 }}>Help us improve — why are you canceling? Select all that apply.</p>
                <div style={{ display:"flex", flexDirection:"column", gap:2, marginBottom:16 }}>
                  {CANCEL_REASONS.map(reason=>(
                    <label key={reason} style={{ display:"flex", alignItems:"center", gap:12, padding:"12px 14px", background:cancelReasons.includes(reason)?BG3:BG2, border:"1px solid " + (cancelReasons.includes(reason)?OR:BG4), borderRadius:10, cursor:"pointer", marginBottom:4 }}>
                      <input
                        type="checkbox"
                        checked={cancelReasons.includes(reason)}
                        onChange={()=>setCancelReasons(prev=>prev.includes(reason)?prev.filter(r=>r!==reason):[...prev,reason])}
                        style={{ width:18, height:18, accentColor:OR, cursor:"pointer", flexShrink:0 }}
                      />
                      <span style={{ color:TEXT, fontSize:14, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>{reason}</span>
                    </label>
                  ))}
                </div>
                <label style={{ color:MUTED, fontSize:11, letterSpacing:2, display:"block", marginBottom:6, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>TELL US MORE (OPTIONAL)</label>
                <textarea
                  value={cancelOtherText}
                  onChange={e=>setCancelOtherText(e.target.value)}
                  placeholder="Any additional feedback..."
                  rows={3}
                  style={{ width:"100%", background:BG3, border:"1px solid " + BG4, color:TEXT, borderRadius:9, padding:"10px 12px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:13, resize:"vertical", outline:"none", lineHeight:1.6, marginBottom:16 }}
                />
                {cancelError && <div style={{ color:"#ef4444", fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:10 }}>{cancelError}</div>}
                <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                  <button
                    onClick={()=>{
                      if (cancelReasons.length===0) { setCancelError("Please select at least one reason."); return; }
                      setCancelError(""); setCancelStep(2);
                    }}
                    style={{ width:"100%", background:"linear-gradient(135deg,#7f1d1d,#991b1b)", color:"#fca5a5", border:"1px solid #ef444440", borderRadius:10, padding:"13px", fontFamily:"'Bebas Neue',sans-serif", fontSize:16, letterSpacing:2, cursor:"pointer" }}
                  >
                    CONTINUE CANCELLATION
                  </button>
                  <button
                    onClick={()=>{ setShowCancelModal(false); setCancelStep(1); setCancelReasons([]); setCancelOtherText(""); setCancelError(""); }}
                    style={{ width:"100%", background:"linear-gradient(135deg," + OR + "," + ORD + ")", color:"#fff", border:"none", borderRadius:10, padding:"13px", fontFamily:"'Bebas Neue',sans-serif", fontSize:16, letterSpacing:2, cursor:"pointer", boxShadow:"0 4px 20px var(--brand-or-25)" }}
                  >
                    NEVER MIND
                  </button>
                </div>
              </>
            )}

            {/* Step 2 — Confirmation */}
            {!cancelDone && cancelStep===2 && (
              <>
                <div style={{ background:"#1a0a0a", border:"1px solid #ef444430", borderRadius:12, padding:"18px", marginBottom:20 }}>
                  <div style={{ color:"#fca5a5", fontSize:14, fontFamily:"'Plus Jakarta Sans',sans-serif", lineHeight:1.7 }}>
                    {currentPeriodEnd
                      ? "You'll keep full access until " + new Date(currentPeriodEnd).toLocaleDateString("en-US",{month:"long",day:"numeric",year:"numeric"}) + ". No further charges."
                      : "You'll keep full access until the end of your current billing period. No further charges."}
                  </div>
                </div>
                {cancelError && <div style={{ color:"#ef4444", fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:10 }}>{cancelError}</div>}
                <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                  <button
                    onClick={()=>{
                      setCancelBusy(true); setCancelError("");
                      onCancelSubscription(
                        cancelReasons,
                        cancelOtherText,
                        (accessUntil)=>{ setCancelBusy(false); setCancelAccessUntil(accessUntil); setCancelDone(true); },
                        (e)=>{ setCancelBusy(false); setCancelError(e); }
                      );
                    }}
                    disabled={cancelBusy}
                    style={{ width:"100%", background:"linear-gradient(135deg,#7f1d1d,#991b1b)", color:"#fca5a5", border:"1px solid #ef444440", borderRadius:10, padding:"13px", fontFamily:"'Bebas Neue',sans-serif", fontSize:16, letterSpacing:2, cursor:cancelBusy?"not-allowed":"pointer", opacity:cancelBusy?0.7:1 }}
                  >
                    {cancelBusy ? "CANCELING..." : "CANCEL SUBSCRIPTION"}
                  </button>
                  <button
                    onClick={()=>{ setShowCancelModal(false); setCancelStep(1); setCancelError(""); }}
                    style={{ width:"100%", background:"linear-gradient(135deg," + OR + "," + ORD + ")", color:"#fff", border:"none", borderRadius:10, padding:"13px", fontFamily:"'Bebas Neue',sans-serif", fontSize:16, letterSpacing:2, cursor:"pointer", boxShadow:"0 4px 20px var(--brand-or-25)" }}
                  >
                    KEEP MY SUBSCRIPTION
                  </button>
                </div>
              </>
            )}

            {/* Done */}
            {cancelDone && (
              <>
                <div style={{ background:"#1a0a0a", border:"1px solid #ef444430", borderRadius:12, padding:"18px", marginBottom:20 }}>
                  <div style={{ color:"#fca5a5", fontSize:14, fontFamily:"'Plus Jakarta Sans',sans-serif", lineHeight:1.7 }}>
                    {"Your subscription has been canceled. Full access continues until "}
                    <strong>{cancelAccessUntil ? new Date(cancelAccessUntil).toLocaleDateString("en-US",{month:"long",day:"numeric",year:"numeric"}) : "end of billing period"}</strong>
                    {". No further charges will be made."}
                  </div>
                </div>
                <button
                  onClick={()=>{ setShowCancelModal(false); setCancelDone(false); setCancelStep(1); }}
                  style={{ width:"100%", background:BG3, color:TEXT, border:"1px solid " + BG4, borderRadius:10, padding:"13px", fontFamily:"'Bebas Neue',sans-serif", fontSize:16, letterSpacing:2, cursor:"pointer" }}
                >
                  DONE
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// ── TEAM ROSTER SCREEN ───────────────────────────────────────────────────────
function TeamScreen({ companyId, sessionUserId }) {
  const [members,       setMembers]       = useState([]);
  const [loading,       setLoading]       = useState(true);
  const [busy,          setBusy]          = useState(null);
  const [confirmRemove, setConfirmRemove] = useState(null);

  useEffect(()=>{ loadMembers(); },[]);// eslint-disable-line react-hooks/exhaustive-deps

  const loadMembers = async () => {
    const { data } = await supabase
      .from("profiles")
      .select("id, full_name, role, active, created_at")
      .eq("company_id", companyId)
      .order("created_at", { ascending: true });
    setMembers(data || []);
    setLoading(false);
  };

  const deactivate = async (id) => {
    setBusy(id);
    await supabase.from("profiles").update({ active: false }).eq("id", id).eq("company_id", companyId);
    await supabase.from("invites").delete().eq("company_id", companyId);
    setMembers(m => m.map(x => x.id === id ? { ...x, active: false } : x));
    setBusy(null);
  };

  const reactivate = async (id) => {
    setBusy(id);
    await supabase.from("profiles").update({ active: true }).eq("id", id).eq("company_id", companyId);
    setMembers(m => m.map(x => x.id === id ? { ...x, active: true } : x));
    setBusy(null);
  };

  const remove = async (id) => {
    setBusy(id);
    setConfirmRemove(null);
    await supabase.from("profiles").delete().eq("id", id).eq("company_id", companyId);
    setMembers(m => m.filter(x => x.id !== id));
    setBusy(null);
  };

  return (
    <div style={{ padding:"24px 16px 100px", animation:"fadeIn .25s ease" }}>
      <h2 style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:28, color:TEXT, letterSpacing:2, marginBottom:4 }}>TEAM ROSTER</h2>
      <div style={{ width:40, height:3, background:"linear-gradient(90deg," + ORD + "," + ORL + ")", borderRadius:2, marginBottom:20 }} />
      <p style={{ color:MUTED, fontSize:13, lineHeight:1.6, marginBottom:24, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>Manage who has access to your account.</p>
      {loading ? (
        <div style={{ textAlign:"center", color:DIM, padding:"32px 0", fontFamily:"'Bebas Neue',sans-serif", letterSpacing:2 }}>LOADING...</div>
      ) : (
        <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
          {members.map(m => {
            const isOwner = m.role === "owner";
            const isSelf  = m.id === sessionUserId;
            const isBusy  = busy === m.id;
            const inactive = m.active === false;
            return (
              <div key={m.id} style={{ background:BG2, border:"1px solid " + (inactive ? "#3a1a1a" : BG4), borderLeft:"3px solid " + (inactive ? "#ef4444" : isOwner ? OR : BG4), borderRadius:12, padding:"14px 16px" }}>
                <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:inactive && !isOwner && !isSelf ? 10 : 0 }}>
                  <Avatar name={m.full_name} size={36} />
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ color:TEXT, fontSize:14, fontWeight:600, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
                      {m.full_name}{isSelf ? " (you)" : ""}
                    </div>
                    <div style={{ display:"flex", alignItems:"center", gap:6, marginTop:2 }}>
                      <span style={{ color:isOwner ? OR : MUTED, fontSize:11, fontFamily:"'Plus Jakarta Sans',sans-serif", textTransform:"capitalize" }}>{m.role}</span>
                      {inactive && <span style={{ color:"#ef4444", fontSize:11, fontWeight:700, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>· INACTIVE</span>}
                    </div>
                  </div>
                  {!isOwner && !isSelf && !inactive && (
                    <button
                      onClick={() => deactivate(m.id)}
                      disabled={isBusy}
                      style={{ background:"#2a0a0a", border:"1px solid #ef444440", color:"#ef4444", borderRadius:8, padding:"6px 12px", fontFamily:"'Bebas Neue',sans-serif", fontSize:12, letterSpacing:1, cursor:"pointer", opacity:isBusy ? 0.6 : 1, whiteSpace:"nowrap" }}
                    >
                      {isBusy ? "..." : "DEACTIVATE"}
                    </button>
                  )}
                </div>
                {inactive && !isOwner && !isSelf && (
                  <div style={{ display:"flex", gap:8 }}>
                    <button
                      onClick={() => reactivate(m.id)}
                      disabled={isBusy}
                      style={{ flex:1, background:"linear-gradient(135deg," + OR + "," + ORD + ")", color:"#fff", border:"none", borderRadius:8, padding:"9px 0", fontFamily:"'Bebas Neue',sans-serif", fontSize:13, letterSpacing:1, cursor:"pointer", opacity:isBusy ? 0.6 : 1 }}
                    >
                      {isBusy ? "..." : "REACTIVATE"}
                    </button>
                    <button
                      onClick={() => setConfirmRemove(m.id)}
                      disabled={isBusy}
                      style={{ background:"none", border:"1px solid #3a1a1a", color:"#ef4444", borderRadius:8, padding:"9px 18px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:12, cursor:"pointer", opacity:isBusy ? 0.6 : 1, whiteSpace:"nowrap" }}
                    >
                      Remove
                    </button>
                  </div>
                )}
              </div>
            );
          })}
          {members.filter(m => m.role !== "owner").length === 0 && (
            <div style={{ textAlign:"center", color:DIM, padding:"32px 0", fontFamily:"'Bebas Neue',sans-serif", fontSize:16, letterSpacing:2 }}>NO CREW MEMBERS YET</div>
          )}
        </div>
      )}
      {confirmRemove && (
        <div onClick={() => setConfirmRemove(null)} style={{ position:"fixed", inset:0, background:"#000d", zIndex:9100, display:"flex", alignItems:"flex-end", justifyContent:"center" }}>
          <div onClick={e => e.stopPropagation()} style={{ background:BG2, border:"1px solid " + BG4, borderRadius:"18px 18px 0 0", width:"100%", maxWidth:480, padding:"28px 22px 40px", animation:"slideUp .25s ease" }}>
            <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:20, color:"#ef4444", letterSpacing:2, marginBottom:10 }}>PERMANENTLY REMOVE?</div>
            <p style={{ color:MUTED, fontSize:13, lineHeight:1.6, marginBottom:24, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>This will permanently remove this crew member. They will not be able to log in. This cannot be undone.</p>
            <div style={{ display:"flex", gap:10 }}>
              <button onClick={() => setConfirmRemove(null)} style={{ flex:1, background:BG3, color:TEXT, border:"1px solid " + BG4, borderRadius:10, padding:"13px", fontFamily:"'Bebas Neue',sans-serif", fontSize:15, letterSpacing:1, cursor:"pointer" }}>CANCEL</button>
              <button onClick={() => remove(confirmRemove)} style={{ flex:1, background:"#2a0a0a", color:"#ef4444", border:"1px solid #ef444440", borderRadius:10, padding:"13px", fontFamily:"'Bebas Neue',sans-serif", fontSize:15, letterSpacing:1, cursor:"pointer" }}>REMOVE</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── NEW USER SETUP SCREEN ─────────────────────────────────────────────────────
// Shown when a confirmed user has no profile record (trigger failed or race).
// Creates the company + profile directly, then onComplete re-routes normally.
function NewUserSetupScreen({ session, onComplete, onSignOut }) {
  const meta = session.user.user_metadata || {};
  const [companyName, setCompanyName] = useState(meta.company_name || "");
  const [fullName,    setFullName]    = useState(meta.full_name    || "");
  const [creating,    setCreating]    = useState(false);
  const [error,       setError]       = useState("");

  const handleCreate = async () => {
    if (!companyName.trim() || !fullName.trim()) { setError("Please fill in all fields"); return; }
    setCreating(true); setError("");
    try {
      const slug = companyName.toLowerCase()
        .replace(/[^a-z0-9]/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "")
        .slice(0, 33) || "company";
      const subdomain = slug + "-" + session.user.id.slice(0, 6);

      const { data: company, error: compErr } = await supabase
        .from("companies")
        .insert({ name: companyName.trim(), owner_id: session.user.id, plan: "trial", trial_ends_at: null, subdomain, logo_size: "medium" })
        .select()
        .single();

      if (compErr) { setError("Could not create company: " + compErr.message); setCreating(false); return; }

      const { error: profErr } = await supabase
        .from("profiles")
        .insert({ id: session.user.id, company_id: company.id, full_name: fullName.trim(), role: "owner" });

      if (profErr) { setError("Could not create profile: " + profErr.message); setCreating(false); return; }

      onComplete();
    } catch (e) {
      setError("Unexpected error: " + e.message);
      setCreating(false);
    }
  };

  const inp = { width:"100%", background:"#2a2e38", border:"1px solid #353a47", color:"#f1f5f9", borderRadius:10, padding:"13px 14px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:14, outline:"none", marginBottom:12 };
  const lbl = { color:"#94a3b8", fontSize:11, letterSpacing:2, display:"block", marginBottom:6 };

  return (
    <div style={{ minHeight:"100vh", background:"#181a1f", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"24px", fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap'); *{box-sizing:border-box;margin:0;padding:0;} input::placeholder{color:#475569;}`}</style>
      <img src="/logo192.png" alt="BeamShots" style={{ height:80, objectFit:"contain", marginBottom:16 }} />
      <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:26, color:"#f1f5f9", letterSpacing:3, marginBottom:6 }}>ALMOST THERE!</div>
      <div style={{ color:"#94a3b8", fontSize:13, marginBottom:28, textAlign:"center", maxWidth:320, lineHeight:1.6 }}>
        Let's finish setting up your company account.
      </div>
      <div style={{ width:"100%", maxWidth:400, background:"#21242c", borderRadius:16, border:"1px solid #353a47", padding:"28px 24px" }}>
        {error && <div style={{ background:"#2a0a0a", border:"1px solid #ef444460", color:"#ef4444", fontSize:13, padding:"10px 14px", borderRadius:8, marginBottom:14 }}>⚠️ {error}</div>}
        <label style={lbl}>YOUR NAME</label>
        <input value={fullName} onChange={e=>setFullName(e.target.value)} placeholder="Barry Smith" style={inp} />
        <label style={lbl}>COMPANY NAME</label>
        <input value={companyName} onChange={e=>setCompanyName(e.target.value)} placeholder="Smith Construction LLC" style={{ ...inp, marginBottom:20 }} onKeyDown={e=>e.key==="Enter"&&handleCreate()} />
        <button onClick={handleCreate} disabled={creating} style={{ width:"100%", background:"linear-gradient(135deg,#f97316,#c2410c)", color:"#fff", border:"none", borderRadius:10, padding:"14px", fontFamily:"'Bebas Neue',sans-serif", fontSize:18, letterSpacing:2, cursor:"pointer", boxShadow:"0 4px 20px #f9731640", opacity:creating?0.7:1 }}>
          {creating ? "SETTING UP..." : "CONTINUE →"}
        </button>
      </div>
      <button onClick={onSignOut} style={{ background:"none", border:"none", color:"#475569", fontSize:12, cursor:"pointer", marginTop:20, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>Sign out</button>
    </div>
  );
}

// ── PAYWALL SCREEN ────────────────────────────────────────────────────────────
const PLAN_CARDS = [
  {
    id: "starter", name: "STARTER", price: 29, color: "#60a5fa", popular: false,
    features: ["1 admin + up to 5 crew","Up to 10 active job sites","Unlimited photo uploads","Analytics dashboard","BeamShots branding"],
  },
  {
    id: "pro", name: "PRO", price: 59, color: "#f97316", popular: true,
    features: ["1 admin + unlimited crew","Unlimited job sites","Unlimited photo uploads","Everything in Starter","Priority support","BeamShots branding"],
  },
  {
    id: "business", name: "BUSINESS", price: 99, color: "#f59e0b", popular: false,
    features: ["1 admin + unlimited crew","Unlimited job sites","Unlimited photo uploads","Everything in Pro","Your logo in the app","Custom color theme","Custom photo categories","Custom crew subdomain + home screen icon","Client portal (coming soon)"],
  },
];

function PaywallScreen({ companyId, email, trialEndsAt, isOwner, onSignOut }) {
  const [checkingOut, setCheckingOut] = useState(null);
  const [checkoutError, setCheckoutError] = useState("");

  const handleChoosePlan = async (planId) => {
    setCheckingOut(planId); setCheckoutError("");
    try {
      const { data, error } = await supabase.functions.invoke("create-checkout-session", {
        body: { plan: planId, companyId, email, trialEndsAt },
      });
      if (error || !data?.url) {
        setCheckoutError("Could not start checkout. Please try again.");
        setCheckingOut(null); return;
      }
      window.location.href = data.url;
    } catch (e) {
      setCheckoutError("Could not start checkout. Please try again.");
      setCheckingOut(null);
    }
  };

  return (
    <div style={{ minHeight:"100vh", background:"#181a1f", display:"flex", flexDirection:"column", alignItems:"center", padding:"32px 16px 48px", fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap'); *{box-sizing:border-box;margin:0;padding:0;}`}</style>
      <img src="/logo192.png" alt="BeamShots" style={{ height:70, objectFit:"contain", marginBottom:20 }} />
      <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:30, color:"#f1f5f9", letterSpacing:3, marginBottom:6, textAlign:"center" }}>
        {isOwner ? "YOUR TRIAL HAS ENDED" : "SUBSCRIPTION REQUIRED"}
      </div>
      <p style={{ color:"#94a3b8", fontSize:14, marginBottom:32, textAlign:"center", maxWidth:340, lineHeight:1.6 }}>
        {isOwner
          ? "Choose a plan to keep your team building. Your photos and jobs are safe."
          : "Your company's trial has ended. Contact your account owner to choose a plan."}
      </p>

      {isOwner && (
        <>
          {checkoutError && (
            <div style={{ background:"#2a0a0a", border:"1px solid #ef444460", color:"#ef4444", fontSize:13, padding:"10px 14px", borderRadius:8, marginBottom:16, width:"100%", maxWidth:420 }}>
              {checkoutError}
            </div>
          )}
          <div style={{ display:"flex", flexDirection:"column", gap:12, width:"100%", maxWidth:420, marginBottom:28 }}>
            {PLAN_CARDS.map(plan => (
              <div key={plan.id} style={{ background:"#21242c", border:"2px solid " + (plan.popular ? plan.color : "#353a47"), borderRadius:16, padding:"20px", position:"relative" }}>
                {plan.popular && (
                  <div style={{ position:"absolute", top:-12, left:"50%", transform:"translateX(-50%)", background:"#f97316", color:"#fff", fontFamily:"'Bebas Neue',sans-serif", fontSize:12, letterSpacing:2, padding:"3px 14px", borderRadius:20, whiteSpace:"nowrap" }}>
                    MOST POPULAR
                  </div>
                )}
                <div style={{ display:"flex", alignItems:"flex-end", justifyContent:"space-between", marginBottom:14 }}>
                  <div>
                    <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:22, color:plan.color, letterSpacing:3 }}>{plan.name}</div>
                    <div style={{ display:"flex", alignItems:"baseline", gap:4 }}>
                      <span style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:36, color:"#f1f5f9" }}>${plan.price}</span>
                      <span style={{ color:"#94a3b8", fontSize:13 }}>/mo</span>
                    </div>
                  </div>
                  <button
                    onClick={() => handleChoosePlan(plan.id)}
                    disabled={checkingOut !== null}
                    style={{ background:"linear-gradient(135deg," + plan.color + "," + (plan.id === "business" ? "#d97706" : plan.id === "pro" ? "#c2410c" : "#2563eb") + ")", color:"#fff", border:"none", borderRadius:10, padding:"10px 20px", fontFamily:"'Bebas Neue',sans-serif", fontSize:15, letterSpacing:2, cursor:checkingOut!==null?"not-allowed":"pointer", opacity:checkingOut!==null?0.7:1, whiteSpace:"nowrap" }}
                  >
                    {checkingOut === plan.id ? "LOADING..." : "CHOOSE PLAN"}
                  </button>
                </div>
                <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
                  {plan.features.map(f => (
                    <div key={f} style={{ display:"flex", alignItems:"center", gap:8, color:"#94a3b8", fontSize:12 }}>
                      <span style={{ color:plan.color, fontSize:12, flexShrink:0 }}>✓</span>{f}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <p style={{ color:"#475569", fontSize:11, textAlign:"center", marginBottom:24, lineHeight:1.6 }}>
            Secure payment via Stripe. Cancel anytime. No hidden fees.
          </p>
        </>
      )}

      <button onClick={onSignOut} style={{ background:"none", border:"1px solid #353a47", color:"#475569", borderRadius:8, padding:"10px 24px", cursor:"pointer", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:13 }}>
        Sign out
      </button>
    </div>
  );
}

// ── TRIAL SETUP SCREEN (new users — card required before trial starts) ─────────
function TrialSetupScreen({ companyId, email, isOwner, onSignOut }) {
  const [checkingOut, setCheckingOut] = useState(null);
  const [checkoutError, setCheckoutError] = useState("");

  const handleStartTrial = async (planId) => {
    setCheckingOut(planId); setCheckoutError("");
    try {
      const { data, error } = await supabase.functions.invoke("create-checkout-session", {
        body: { plan: planId, companyId, email, startTrial: true },
      });
      if (error || !data?.url) {
        setCheckoutError("Could not start checkout. Please try again.");
        setCheckingOut(null); return;
      }
      window.location.href = data.url;
    } catch (e) {
      setCheckoutError("Could not start checkout. Please try again.");
      setCheckingOut(null);
    }
  };

  return (
    <div style={{ minHeight:"100vh", background:"#181a1f", display:"flex", flexDirection:"column", alignItems:"center", padding:"32px 16px 48px", fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap'); *{box-sizing:border-box;margin:0;padding:0;}`}</style>
      <img src="/logo192.png" alt="BeamShots" style={{ height:70, objectFit:"contain", marginBottom:20 }} />
      <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:30, color:"#f1f5f9", letterSpacing:3, marginBottom:6, textAlign:"center" }}>
        {isOwner ? "START YOUR FREE TRIAL" : "ACCOUNT SETUP REQUIRED"}
      </div>
      <p style={{ color:"#94a3b8", fontSize:14, marginBottom:32, textAlign:"center", maxWidth:340, lineHeight:1.6 }}>
        {isOwner
          ? "Enter your card to start a 14-day free trial. You won't be charged until the trial ends. Cancel anytime."
          : "Your company account is still being set up. Contact your account owner to complete signup."}
      </p>

      {isOwner && (
        <>
          {checkoutError && (
            <div style={{ background:"#2a0a0a", border:"1px solid #ef444460", color:"#ef4444", fontSize:13, padding:"10px 14px", borderRadius:8, marginBottom:16, width:"100%", maxWidth:420 }}>
              {checkoutError}
            </div>
          )}
          <div style={{ display:"flex", flexDirection:"column", gap:12, width:"100%", maxWidth:420, marginBottom:28 }}>
            {PLAN_CARDS.map(plan => (
              <div key={plan.id} style={{ background:"#21242c", border:"2px solid " + (plan.popular ? plan.color : "#353a47"), borderRadius:16, padding:"20px", position:"relative" }}>
                {plan.popular && (
                  <div style={{ position:"absolute", top:-12, left:"50%", transform:"translateX(-50%)", background:"#f97316", color:"#fff", fontFamily:"'Bebas Neue',sans-serif", fontSize:12, letterSpacing:2, padding:"3px 14px", borderRadius:20, whiteSpace:"nowrap" }}>
                    MOST POPULAR
                  </div>
                )}
                <div style={{ display:"flex", alignItems:"flex-end", justifyContent:"space-between", marginBottom:14 }}>
                  <div>
                    <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:22, color:plan.color, letterSpacing:3 }}>{plan.name}</div>
                    <div style={{ display:"flex", alignItems:"baseline", gap:4 }}>
                      <span style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:36, color:"#f1f5f9" }}>${plan.price}</span>
                      <span style={{ color:"#94a3b8", fontSize:13 }}>/mo</span>
                    </div>
                  </div>
                  <button
                    onClick={() => handleStartTrial(plan.id)}
                    disabled={checkingOut !== null}
                    style={{ background:"linear-gradient(135deg," + plan.color + "," + (plan.id === "business" ? "#d97706" : plan.id === "pro" ? "#c2410c" : "#2563eb") + ")", color:"#fff", border:"none", borderRadius:10, padding:"10px 20px", fontFamily:"'Bebas Neue',sans-serif", fontSize:15, letterSpacing:2, cursor:checkingOut!==null?"not-allowed":"pointer", opacity:checkingOut!==null?0.7:1, whiteSpace:"nowrap" }}
                  >
                    {checkingOut === plan.id ? "LOADING..." : "START TRIAL"}
                  </button>
                </div>
                <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
                  {plan.features.map(f => (
                    <div key={f} style={{ display:"flex", alignItems:"center", gap:8, color:"#94a3b8", fontSize:12 }}>
                      <span style={{ color:plan.color, fontSize:12, flexShrink:0 }}>✓</span>{f}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <p style={{ color:"#475569", fontSize:11, textAlign:"center", marginBottom:24, lineHeight:1.6 }}>
            14-day free trial. Card required to prevent abuse. Cancel anytime before trial ends and you won't be charged.
          </p>
        </>
      )}

      <button onClick={onSignOut} style={{ background:"none", border:"1px solid #353a47", color:"#475569", borderRadius:8, padding:"10px 24px", cursor:"pointer", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:13 }}>
        Sign out
      </button>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// MAIN APP
// ══════════════════════════════════════════════════════════════════════════════
export default function App() {
  const [session,        setSession]        = useState(null);
  const [authLoading,    setAuthLoading]    = useState(true);
  const [profile,        setProfile]        = useState(null);
  const [companyId,      setCompanyId]      = useState(null);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [profileMissing, setProfileMissing] = useState(false);

  const inviteToken = new URLSearchParams(window.location.search).get("invite");

  useEffect(()=>{
    // Detect return from Stripe Checkout
    const params = new URLSearchParams(window.location.search);
    if (params.get("payment") === "success") {
      window.history.replaceState({}, "", window.location.pathname);
      setPaymentSuccess(true);
    }

    supabase.auth.getSession().then(({ data:{ session } })=>{
      setSession(session);
      if (session) {
        loadProfile(session.user.id);
        // Re-fetch profile after delay so webhook-updated plan is picked up.
        // Pass true so a missing profile here doesn't trigger the setup screen.
        if (params.get("payment") === "success") {
          setTimeout(() => loadProfile(session.user.id, true), 3000);
        }
      } else { setAuthLoading(false); }
    });
    const { data:{ subscription } } = supabase.auth.onAuthStateChange((_event, session)=>{
      setSession(session);
      if (session) loadProfile(session.user.id);
      else { setAuthLoading(false); setProfile(null); setCompanyId(null); setProfileMissing(false); }
    });
    return () => subscription.unsubscribe();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  // Watch for deactivation in real-time and re-check on tab focus
  useEffect(()=>{
    if (!session) return;
    const userId = session.user.id;
    const channel = supabase.channel("profile-active-" + userId)
      .on("postgres_changes", { event:"UPDATE", schema:"public", table:"profiles", filter:"id=eq." + userId }, (payload) => {
        if (payload.new && payload.new.active === false) supabase.auth.signOut();
      })
      .subscribe();
    const handleVisibility = () => {
      if (document.visibilityState === "visible") loadProfile(userId, true);
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () => {
      supabase.removeChannel(channel);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[session]);

  // isRetry=true skips the 3-second retry (used after payment or after we just created the record).
  const loadProfile = async (userId, isRetry = false) => {
    const { data } = await supabase.from("profiles").select("*, companies(*)").eq("id", userId).single();
    if (data) {
      if (data.active === false) {
        await supabase.auth.signOut();
        setSession(null); setProfile(null); setCompanyId(null); setProfileMissing(false);
        setAuthLoading(false);
        return;
      }
      setProfile(data);
      setCompanyId(data.company_id);
      setProfileMissing(false);
      setAuthLoading(false);
    } else if (!isRetry) {
      // No profile yet — wait 3 s and retry once (trigger may not have committed).
      // authLoading stays true so the spinner shows during the wait.
      setTimeout(() => loadProfile(userId, true), 3000);
    } else {
      // Still nothing after retry — the trigger failed. Show the setup screen.
      setProfileMissing(true);
      setAuthLoading(false);
    }
  };

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    setSession(null); setProfile(null); setCompanyId(null); setProfileMissing(false);
  };

  if (authLoading) return (
    <div style={{ minHeight:"100vh", background:"#181a1f", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:20 }}>
      <img src="/logo192.png" alt="BeamShots" style={{ height:90, objectFit:"contain" }} />
      <div style={{ width:44, height:44, border:"3px solid #f97316", borderTopColor:"transparent", borderRadius:"50%", animation:"spin .7s linear infinite" }} />
      <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:20, color:"#f97316", letterSpacing:4 }}>LOADING...</div>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );

  if (!session) return <AuthScreen inviteToken={inviteToken} onAuth={()=>supabase.auth.getSession().then(({data:{session}})=>{ setSession(session); if(session) loadProfile(session.user.id); })} />;

  // Authenticated but no profile record — trigger failed. Let them finish setup.
  if (profileMissing) {
    return (
      <NewUserSetupScreen
        session={session}
        onComplete={() => { setAuthLoading(true); loadProfile(session.user.id, true); }}
        onSignOut={handleSignOut}
      />
    );
  }

  const billing = getBillingStatus(profile?.companies);

  if (billing.access === "setup_required") {
    return (
      <TrialSetupScreen
        companyId={companyId}
        email={session.user.email}
        isOwner={profile?.role === "owner"}
        onSignOut={handleSignOut}
      />
    );
  }

  if (billing.access === "expired") {
    return (
      <PaywallScreen
        companyId={companyId}
        email={session.user.email}
        trialEndsAt={profile?.companies?.trial_ends_at}
        isOwner={profile?.role === "owner"}
        onSignOut={handleSignOut}
      />
    );
  }

  return <MainApp session={session} profile={profile} companyId={companyId} onSignOut={handleSignOut} billing={billing} paymentSuccess={paymentSuccess} />;
}

function MainApp({ session, profile, companyId, onSignOut, billing, paymentSuccess }) {
  const [jobs,          setJobs]          = useState([]);
  const [photos,        setPhotos]        = useState([]);
  const [loading,       setLoading]       = useState(true);
  const [activeJob,     setActiveJob]     = useState(null);
  const [view,          setView]          = useState("home");
  const [uploading,     setUploading]     = useState(false);
  const [toast,         setToast]         = useState(null);
  const [search,        setSearch]        = useState("");
  const [filterSt,      setFilterSt]      = useState("all");
  const [filterCat,     setFilterCat]     = useState("All");
  const [username] = useState(profile?.full_name || localStorage.getItem("bs_username") || "");
  const [form,          setForm]          = useState({ name:"", address:"", description:"", status:"active", estimated_days:"" });
  const [showCrew,      setShowCrew]      = useState(false);
  const [showInvite,    setShowInvite]    = useState(false);
  const [inviteLink,    setInviteLink]    = useState("");
  const [uploadCat,     setUploadCat]     = useState("General");
  const [jobTab,        setJobTab]        = useState("photos");
  const [isAdmin,       setIsAdmin]       = useState(profile?.role === "owner");
  const [showAdminModal,setShowAdminModal]= useState(false);
  const [adminPassword, setAdminPassword] = useState("");
  const [branding,      setBranding]      = useState({
    logoUrl:            profile?.companies?.logo_url            || null,
    primaryColor:       profile?.companies?.primary_color       || "#f97316",
    secondaryColor:     profile?.companies?.secondary_color     || "#f59e0b",
    tagline:            profile?.companies?.tagline             || null,
    logoSize:           profile?.companies?.logo_size           || "medium",
    subdomain:          profile?.companies?.subdomain           || null,
    primaryTrade:       profile?.companies?.primary_trade       || "",
    primaryRegion:      profile?.companies?.primary_region      || "",
    companySpecialties: profile?.companies?.company_specialties || [],
    athenaEnabled:      profile?.companies?.athena_enabled      !== false,
  });
  const [showAthena, setShowAthena] = useState(false);
  const [staleThreshold,    setStaleThreshold]    = useState(profile?.companies?.stale_threshold_days !== undefined ? profile.companies.stale_threshold_days : 2);
  const [staleAlertsEnabled,setStaleAlertsEnabled]= useState(profile?.companies?.stale_alerts_enabled !== false);
  const [checkingOut,      setCheckingOut]      = useState(null);
  const [checkoutError,    setCheckoutError]    = useState("");
  const [cancelAtPeriodEnd,setCancelAtPeriodEnd]= useState(profile?.companies?.cancel_at_period_end || false);
  const [currentPeriodEnd, setCurrentPeriodEnd] = useState(profile?.companies?.current_period_end  || null);
  const [customCategories, setCustomCategories] = useState([]);

  const logoSrc    = branding.logoUrl || LOGO_URL;
  const isAiEnabled = billing?.plan === "pro" || billing?.plan === "business" || billing?.plan === "grandfathered";
  const allCategories = [...CATEGORIES, ...customCategories];
  const logoH   = LOGO_HEIGHTS[branding.logoSize] || 42;
  const rgb     = hexToRgb(branding.primaryColor);
  const ordRgb  = hexToRgb(hexAdjust(branding.primaryColor, -55));
  const brandVars = {
    "--brand-or":     branding.primaryColor,
    "--brand-orl":    hexAdjust(branding.primaryColor, 28),
    "--brand-ord":    hexAdjust(branding.primaryColor, -55),
    "--brand-or-05":  "rgba(" + rgb + ",0.05)",
    "--brand-or-25":  "rgba(" + rgb + ",0.25)",
    "--brand-ord-25": "rgba(" + ordRgb + ",0.25)",
  };

  const showToast = msg=>{ setToast(msg); setTimeout(()=>setToast(null),2500); };

  const handleChoosePlan = async (planId) => {
    setCheckingOut(planId); setCheckoutError("");
    try {
      const { data, error } = await supabase.functions.invoke("create-checkout-session", {
        body: { plan: planId, companyId, email: session.user.email, trialEndsAt: profile?.companies?.trial_ends_at || null },
      });
      if (error || !data?.url) { setCheckoutError("Could not start checkout. Please try again."); setCheckingOut(null); return; }
      window.location.href = data.url;
    } catch (e) {
      setCheckoutError("Could not start checkout. Please try again."); setCheckingOut(null);
    }
  };

  const handleCancelSubscription = async (reasons, additionalComments, onSuccess, onError) => {
    try {
      const { data, error } = await supabase.functions.invoke("cancel-subscription", {
        body: { companyId, reasons, additionalComments },
      });
      if (error || !data?.success) { onError("Cancellation failed. Please try again."); return; }
      setCancelAtPeriodEnd(true);
      setCurrentPeriodEnd(data.accessUntil);
      onSuccess(data.accessUntil);
    } catch (e) { onError("Cancellation failed. Please try again."); }
  };

  const handleReactivateSubscription = async (onSuccess, onError) => {
    try {
      const { data, error } = await supabase.functions.invoke("reactivate-subscription", {
        body: { companyId },
      });
      if (error || !data?.success) { onError("Reactivation failed. Please try again."); return; }
      setCancelAtPeriodEnd(false);
      onSuccess();
    } catch (e) { onError("Reactivation failed. Please try again."); }
  };

  const handleOpenPortal = async (onDone) => {
    try {
      const { data, error } = await supabase.functions.invoke("create-portal-session", {
        body: { companyId },
      });
      if (error || !data?.url) { showToast("Could not open billing portal"); if(onDone) onDone(); return; }
      window.location.href = data.url;
    } catch (e) { showToast("Could not open billing portal"); if(onDone) onDone(); }
  };

  const handleSaveCustomCategories = async (cats, onSuccess, onError) => {
    try {
      await supabase.from("settings")
        .upsert({ key:"custom_categories", value:JSON.stringify(cats), company_id:companyId, updated_at:new Date().toISOString() },
                 { onConflict:"key,company_id" });
      setCustomCategories(cats);
      if (onSuccess) onSuccess();
    } catch(e) { if (onError) onError(e.message || "Save failed"); }
  };

  const triggerCategorization = async (photoId, imageUrl) => {
    try {
      const resp = await fetch("/api/categorize-photo", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ imageUrl, categories: allCategories }),
      });
      if (!resp.ok) return;
      const { suggestedCategory } = await resp.json();
      if (!suggestedCategory) return;
      await supabase.from("photos").update({
        suggested_category: suggestedCategory,
        category_confirmed: false,
        ai_processed_at: new Date().toISOString(),
      }).eq("id", photoId).eq("company_id", companyId);
      setPhotos(prev => prev.map(p => p.id === photoId
        ? { ...p, suggested_category: suggestedCategory, category_confirmed: false }
        : p
      ));
    } catch (e) { /* silent fail — categorization is optional */ }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(()=>{ loadAll(); },[]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(()=>{ if(paymentSuccess){ setToast("PAYMENT SUCCESSFUL ✓"); setTimeout(()=>setToast(null),2500); } },[paymentSuccess]);

  // branding is initialised from the profile prop, but MainApp mounts before
  // loadProfile resolves so the initial value is all-null. Sync it once the
  // parent passes down real company data.
  useEffect(()=>{
    if (!profile?.companies) return;
    setBranding(b => ({
      ...b,
      logoUrl:            profile.companies.logo_url            || null,
      primaryColor:       profile.companies.primary_color       || "#f97316",
      secondaryColor:     profile.companies.secondary_color     || "#f59e0b",
      tagline:            profile.companies.tagline             || null,
      logoSize:           profile.companies.logo_size           || "medium",
      subdomain:          profile.companies.subdomain           || null,
      primaryTrade:       profile.companies.primary_trade       || "",
      primaryRegion:      profile.companies.primary_region      || "",
      companySpecialties: profile.companies.company_specialties || [],
      athenaEnabled:      profile.companies.athena_enabled      !== false,
    }));
    setCancelAtPeriodEnd(profile.companies.cancel_at_period_end || false);
    setCurrentPeriodEnd(profile.companies.current_period_end   || null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[profile]);

  useEffect(()=>{
    console.log("[pwa-links] subdomain:", branding.subdomain);
    if (!branding.subdomain) return;
    const icon = document.querySelector('link[rel="apple-touch-icon"]');
    if (icon) icon.href = '/api/apple-icon?company=' + branding.subdomain;
    const mf = document.querySelector('link[rel="manifest"]');
    if (mf) mf.href = '/api/manifest?company=' + branding.subdomain;
    console.log("[pwa-links] patched icon →", icon && icon.href, "manifest →", mf && mf.href);
  },[branding.subdomain]);

  const loadAll = async () => {
    setLoading(true);
    const [{ data:jobData },{ data:photoData },{ data:settingsData }] = await Promise.all([
      supabase.from("jobs").select("*").eq("company_id", companyId).order("created_at",{ascending:false}),
      supabase.from("photos").select("*").eq("company_id", companyId).order("created_at",{ascending:true}),
      supabase.from("settings").select("*").eq("company_id", companyId),
    ]);
    setJobs(jobData||[]);
    setPhotos(photoData||[]);
    const pwSetting = (settingsData||[]).find(s=>s.key==="admin_password");
    if (pwSetting) setAdminPassword(pwSetting.value);
    const catSetting = (settingsData||[]).find(s=>s.key==="custom_categories");
    if (catSetting) { try { setCustomCategories(JSON.parse(catSetting.value)||[]); } catch(e) {} }
    setLoading(false);
  };

  const saveAdminPw  = async (pw) => {
    await supabase.from("settings")
      .upsert({ key:"admin_password", value:pw, company_id:companyId, updated_at:new Date().toISOString() },
               { onConflict:"key,company_id" });
    setAdminPassword(pw);
  };

  const filteredJobs = jobs.filter(j=>{
    const ms=!search||j.name.toLowerCase().includes(search.toLowerCase())||(j.address||"").toLowerCase().includes(search.toLowerCase());
    const mf=filterSt==="all"||j.status===filterSt;
    return ms&&mf;
  });

  const jobPhotos      = photos.filter(p=>p.job_id===activeJob?.id);
  const filteredPhotos = filterCat==="All"?jobPhotos:jobPhotos.filter(p=>(p.category||"General")===filterCat);
  const usedCats       = [...new Set(jobPhotos.map(p=>p.category||"General"))];
  const staleCount     = jobs.filter(j=>j.status==="active"&&buildJobAnalytics(j,photos,staleThreshold,staleAlertsEnabled).momentum==="stale").length;

  const handleUpload = async (files) => {
    if (!activeJob) return;
    if (!username.trim()) { showToast("SET YOUR NAME FIRST ↑"); return; }
    setUploading(true);
    let successCount = 0;
    let failCount = 0;
    for (const file of files) {
      try {
        const ext  = file.name.split(".").pop().toLowerCase();
        const safeExt = ["jpg","jpeg","png","gif","webp","heic"].includes(ext) ? ext : "jpg";
        const path = activeJob.id + "/" + Date.now() + "_" + Math.random().toString(36).slice(2) + "." + safeExt;
        const { error: upErr } = await supabase.storage.from("photos").upload(path, file, {
          cacheControl: "3600",
          upsert: false,
          contentType: file.type || "image/jpeg",
        });
        if (upErr) { console.error("Storage error:", upErr); failCount++; continue; }
        const { data: urlData } = supabase.storage.from("photos").getPublicUrl(path);
        const publicUrl = urlData?.publicUrl;
        if (!publicUrl) { failCount++; continue; }
        const { data: newPhoto, error: dbErr } = await supabase.from("photos").insert({
          job_id:activeJob.id, name:file.name, image_url:publicUrl,
          storage_path:path, uploader_name:profile?.full_name||username, category:uploadCat, note:"",
          company_id:companyId,
        }).select().single();
        if (dbErr) { console.error("DB error:", dbErr); failCount++; continue; }
        if (newPhoto) {
          setPhotos(prev=>[...prev, newPhoto]);
          successCount++;
          if (isAiEnabled) triggerCategorization(newPhoto.id, publicUrl);
        }
      } catch(e) { console.error("Upload exception:", e); failCount++; }
    }
    setUploading(false);
    if (successCount > 0 && failCount === 0) showToast(successCount + " PHOTO" + (successCount>1?"S":"") + " UPLOADED ✓");
    else if (successCount > 0) showToast(successCount + " UPLOADED, " + failCount + " FAILED");
    else showToast("UPLOAD FAILED — CHECK CONNECTION");
  };

  const deletePhoto = async (photoId) => {
    if (!isAdmin) return;
    const photo = photos.find(p=>p.id===photoId);
    if (photo?.storage_path) await supabase.storage.from("photos").remove([photo.storage_path]);
    await supabase.from("photos").delete().eq("id", photoId).eq("company_id", companyId);
    setPhotos(prev=>prev.filter(p=>p.id!==photoId));
    showToast("PHOTO REMOVED");
  };

  const updatePhoto = async (photoId, changes) => {
    await supabase.from("photos").update(changes).eq("id", photoId).eq("company_id", companyId);
    setPhotos(prev=>prev.map(p=>p.id===photoId?{...p,...changes}:p));
  };

  const saveJob = async () => {
    if (!isAdmin||!form.name.trim()) return;
    const data = { name:form.name, address:form.address, description:form.description, status:form.status, estimated_days:form.estimated_days?parseInt(form.estimated_days):null, crew:form.crew||[], company_id:companyId };
    if (view==="newjob") {
      const { data:newJob } = await supabase.from("jobs").insert(data).select().single();
      if (newJob) setJobs(prev=>[newJob,...prev]);
      showToast("JOB CREATED ✓"); setView("home");
    } else {
      await supabase.from("jobs").update(data).eq("id",form.id).eq("company_id",companyId);
      setJobs(prev=>prev.map(j=>j.id===form.id?{...j,...data}:j));
      if (activeJob?.id===form.id) setActiveJob(j=>({...j,...data}));
      showToast("JOB UPDATED ✓"); setView("job");
    }
    setForm({name:"",address:"",description:"",status:"active",estimated_days:""});
  };

  const deleteJob = async (jobId) => {
    if (!isAdmin) return;
    await supabase.from("photos").delete().eq("job_id",jobId).eq("company_id",companyId);
    await supabase.from("jobs").delete().eq("id",jobId).eq("company_id",companyId);
    setJobs(prev=>prev.filter(j=>j.id!==jobId));
    setPhotos(prev=>prev.filter(p=>p.job_id!==jobId));
    showToast("JOB REMOVED"); setView("home");
  };

  const saveCrew = async (members) => {
    if (!isAdmin) return;
    await supabase.from("jobs").update({crew:members}).eq("id",activeJob.id).eq("company_id",companyId);
    setJobs(prev=>prev.map(j=>j.id===activeJob.id?{...j,crew:members}:j));
    setActiveJob(j=>({...j,crew:members}));
    setShowCrew(false); showToast("CREW SAVED ✓");
  };

  const generateInvite = async () => {
    const { data, error } = await supabase.from("invites").insert({
      company_id: companyId,
      created_by: session.user.id,
    }).select().single();
    if (error) { showToast("FAILED TO CREATE INVITE"); return; }
    const link = window.location.origin + "?invite=" + data.token;
    setInviteLink(link);
    setShowInvite(true);
  };

  const openJob  = (job)   => { setActiveJob(job); setFilterCat("All"); setJobTab("photos"); setView("job"); };
  const openEdit = (job,e) => { if(!isAdmin) return; e?.stopPropagation(); setForm({...job,estimated_days:job.estimated_days||""}); setView("editjob"); };
  const openNew  = ()      => { if(!isAdmin) return; setForm({name:"",address:"",description:"",status:"active",estimated_days:""}); setView("newjob"); };
  const lockAdmin= ()      => { setIsAdmin(false); showToast("ADMIN MODE OFF"); };

  const inp={ width:"100%", background:BG3, border:"1px solid " + BG4, color:TEXT, borderRadius:9, padding:"12px 14px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:14, outline:"none", marginBottom:12 };
  const FILTERS=["all","active","completed","on hold"];

  if (loading) return (
    <div style={{ minHeight:"100vh", background:"linear-gradient(160deg,#1f2330 0%," + BG + " 100%)", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:20, ...brandVars }}>
      <img src={logoSrc} alt="BeamShots" style={{ height:90, objectFit:"contain" }} onError={e=>{e.target.style.display="none";}} />
      <div style={{ width:44, height:44, border:"3px solid " + OR, borderTopColor:"transparent", borderRadius:"50%", animation:"spin .7s linear infinite" }} />
      <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:20, color:OR, letterSpacing:4 }}>LOADING BEAM SHOTS...</div>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );

  return (
    <div style={{ minHeight:"100vh", background:BG, fontFamily:"'Plus Jakarta Sans',sans-serif", maxWidth:480, margin:"0 auto", ...brandVars }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');
        *{box-sizing:border-box;margin:0;padding:0;}
        body{background:#181a1f;}
        @keyframes spin{to{transform:rotate(360deg)}}
        @keyframes fadeUp{from{opacity:0;transform:translateX(-50%) translateY(12px)}to{opacity:1;transform:translateX(-50%) translateY(0)}}
        @keyframes fadeIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}
        @keyframes slideUp{from{transform:translateY(100%)}to{transform:translateY(0)}}
        @keyframes pulse{0%,100%{opacity:.3;transform:scale(.75)}50%{opacity:1;transform:scale(1.1)}}
        input::placeholder,textarea::placeholder{color:#475569;}
        select option{background:#2a2e38;}
        ::-webkit-scrollbar{width:4px;}
        ::-webkit-scrollbar-track{background:#181a1f;}
        ::-webkit-scrollbar-thumb{background:#353a47;border-radius:2px;}
      `}</style>

      {/* HEADER */}
      <header style={{ background:"linear-gradient(160deg,#1a1c22 0%," + BG + " 100%)", borderBottom:"1px solid " + BG4, padding:"0 12px", height:76, display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:100, boxShadow:"0 2px 20px #00000060" }}>
        <div style={{ display:"flex", alignItems:"center", gap:6, cursor:"pointer", flex:1, minWidth:0, overflow:"hidden" }} onClick={()=>setView("home")}>
          {branding.logoUrl ? (
            <img src={logoSrc} alt={profile?.companies?.name||"BeamShots"} style={{ height:logoH, maxWidth:130, objectFit:"contain", flexShrink:1 }} onError={e=>{e.target.style.display="none";}} />
          ) : (
            <>
              <img src={LOGO_URL} alt="BeamShots" style={{ height:48, width:48, objectFit:"contain", flexShrink:0 }} onError={e=>{e.target.style.display="none";}} />
              <div style={{ minWidth:0, overflow:"hidden" }}>
                <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:18, color:TEXT, letterSpacing:3, lineHeight:1, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>BEAM SHOTS</div>
                <div style={{ color:OR, fontSize:9, letterSpacing:2, fontWeight:700, marginTop:2, whiteSpace:"nowrap" }}>JOBSITE PHOTOS</div>
              </div>
            </>
          )}
        </div>
        <div style={{ display:"flex", alignItems:"center", gap:4, flexShrink:0 }}>
          {(view==="job"||view==="editjob")&&<button onClick={()=>setView(view==="editjob"?"job":"home")} style={{ background:"none", border:"none", color:MUTED, fontSize:11, cursor:"pointer", fontFamily:"'Plus Jakarta Sans',sans-serif", padding:"4px 2px" }}>‹ Back</button>}
          {(view==="newjob"||view==="settings"||view==="plans"||view==="team"||view==="churn")&&<button onClick={()=>setView("home")} style={{ background:"none", border:"none", color:MUTED, fontSize:11, cursor:"pointer", fontFamily:"'Plus Jakarta Sans',sans-serif", padding:"4px 2px" }}>‹ Back</button>}
          {isAdmin
            ? <button onClick={lockAdmin} style={{ background:"linear-gradient(135deg," + ORD + ",#7a2800)", border:"1px solid " + OR, color:"#fff", borderRadius:7, padding:"4px 7px", cursor:"pointer", fontSize:14, lineHeight:1 }} title="Admin Mode On">🔓</button>
            : <button onClick={()=>setShowAdminModal(true)} style={{ background:BG3, border:"1px solid " + BG4, color:MUTED, borderRadius:7, padding:"4px 7px", cursor:"pointer", fontSize:14, lineHeight:1 }} title="Admin Login">🔐</button>
          }
          {isAdmin && <button onClick={generateInvite} style={{ background:"linear-gradient(135deg," + OR + "," + ORD + ")", border:"none", color:"#fff", borderRadius:7, padding:"4px 9px", cursor:"pointer", fontFamily:"'Bebas Neue',sans-serif", fontSize:12, letterSpacing:1, boxShadow:"0 2px 10px var(--brand-or-25)" }}>+</button>}
          {isAdmin && <button onClick={()=>setView("settings")} style={{ background:BG3, border:"1px solid " + BG4, color:MUTED, borderRadius:7, padding:"4px 6px", cursor:"pointer", fontSize:14, lineHeight:1 }} title="Settings">⚙️</button>}
          <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:1, marginLeft:2 }}>
            <span style={{ color:TEXT, fontSize:10, fontWeight:600, fontFamily:"'Plus Jakarta Sans',sans-serif", whiteSpace:"nowrap" }}>👷 {(profile?.full_name||username||"You").split(" ")[0]}</span>
            <button onClick={onSignOut} style={{ background:"none", border:"none", color:DIM, fontSize:10, cursor:"pointer", fontFamily:"'Plus Jakarta Sans',sans-serif" }}>Sign out</button>
          </div>
        </div>
      </header>

      {isAdmin&&<div style={{ background:"linear-gradient(135deg,var(--brand-ord-25)," + BG2 + ")", borderBottom:"1px solid var(--brand-or-25)", padding:"8px 16px", display:"flex", alignItems:"center", justifyContent:"space-between" }}><span style={{ color:ORL, fontSize:12, fontFamily:"'Bebas Neue',sans-serif", letterSpacing:2 }}>🔓 ADMIN MODE — FULL ACCESS ENABLED</span><div style={{ display:"flex", gap:8, alignItems:"center" }}>{process.env.REACT_APP_MASTER_ADMIN_EMAIL && session.user.email===process.env.REACT_APP_MASTER_ADMIN_EMAIL && <button onClick={()=>setView("churn")} style={{ background:"none", border:"1px solid " + BG4, color:ORL, fontSize:10, cursor:"pointer", fontFamily:"'Bebas Neue',sans-serif", letterSpacing:1, padding:"3px 8px", borderRadius:5 }}>📊 CHURN</button>}<button onClick={lockAdmin} style={{ background:"none", border:"none", color:ORL, fontSize:11, cursor:"pointer", fontFamily:"'Plus Jakarta Sans',sans-serif", opacity:.8 }}>Lock</button></div></div>}

      {billing?.access==="trial"&&(
        <div style={{ background:"linear-gradient(135deg,#1e2a1a," + BG2 + ")", borderBottom:"1px solid #4ade8040", padding:"8px 16px", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <span style={{ color:"#4ade80", fontSize:11, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>{"Free trial — " + billing.daysLeft + " day" + (billing.daysLeft===1?"":"s") + " left"}</span>
          {profile?.role==="owner"&&<button onClick={()=>setView("plans")} style={{ background:"none", border:"1px solid #4ade8060", color:"#4ade80", fontSize:10, cursor:"pointer", fontFamily:"'Bebas Neue',sans-serif", letterSpacing:1, padding:"3px 8px", borderRadius:5 }}>CHOOSE PLAN</button>}
        </div>
      )}

      {/* BOTTOM NAV */}
      {(view==="home"||view==="analytics"||view==="team")&&(
        <div style={{ position:"fixed", bottom:0, left:"50%", transform:"translateX(-50%)", width:"100%", maxWidth:480, background:"linear-gradient(160deg,#1f2330," + BG + ")", borderTop:"1px solid " + BG4, display:"flex", zIndex:99, boxShadow:"0 -4px 20px #00000060" }}>
          {[{id:"home",icon:"🏗️",label:"JOBS"},{id:"analytics",icon:"📊",label:"ANALYTICS",badge:staleCount},{id:"team",icon:"👥",label:"TEAM"}].filter(t=>t.id!=="team"||profile?.role==="owner").map(t=>(
            <button key={t.id} onClick={()=>setView(t.id)} style={{ flex:1, background:"none", border:"none", padding:"12px 0 10px", cursor:"pointer", display:"flex", flexDirection:"column", alignItems:"center", gap:3, position:"relative" }}>
              <span style={{ fontSize:20 }}>{t.icon}</span>
              <span style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:11, letterSpacing:2, color:view===t.id?OR:DIM }}>{t.label}</span>
              {view===t.id&&<div style={{ position:"absolute", bottom:0, left:"50%", transform:"translateX(-50%)", width:32, height:2, background:"linear-gradient(90deg," + ORD + "," + ORL + ")", borderRadius:2 }} />}
              {t.badge>0&&<span style={{ position:"absolute", top:8, right:"calc(50% - 18px)", background:"#ef4444", color:"#fff", fontSize:9, fontWeight:700, width:16, height:16, borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center" }}>{t.badge}</span>}
            </button>
          ))}
        </div>
      )}

      {/* HOME */}
      {view==="home"&&(
        <div style={{ animation:"fadeIn .25s ease", paddingBottom:80 }}>
          <div style={{ background:"linear-gradient(180deg,#1f2330 0%," + BG + " 100%)", padding:"22px 16px 18px" }}>
            <div style={{ display:"flex", alignItems:"flex-start", justifyContent:"space-between", marginBottom:8 }}>
              <div>
                <h1 style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:36, color:TEXT, letterSpacing:1.5, lineHeight:1 }}>Job Sites</h1>
                <div style={{ width:44, height:3, background:"linear-gradient(90deg," + ORD + "," + ORL + ")", borderRadius:2, marginTop:7 }} />
              </div>
              {isAdmin
                ? <button onClick={openNew} style={{ background:"linear-gradient(135deg," + OR + "," + ORD + ")", color:"#fff", border:"none", borderRadius:10, padding:"11px 18px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:14, fontWeight:700, cursor:"pointer", boxShadow:"0 4px 18px var(--brand-or-25)", marginTop:4, flexShrink:0 }}>+ New Site</button>
                : <div style={{ background:BG3, border:"1px solid " + BG4, borderRadius:10, padding:"11px 14px", fontSize:12, color:MUTED }}>👁 View Only</div>
              }
            </div>
            <p style={{ color:MUTED, fontSize:13, lineHeight:1.65, marginBottom:18 }}>{branding.tagline || DEFAULT_TAGLINE}</p>
            <div style={{ position:"relative", marginBottom:12 }}>
              <span style={{ position:"absolute", left:12, top:"50%", transform:"translateY(-50%)", color:DIM, fontSize:14 }}>🔍</span>
              <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search by name or location..." style={{ ...inp, marginBottom:0, paddingLeft:36 }} />
            </div>
            <div style={{ display:"flex", gap:6, marginBottom:20, overflowX:"auto", paddingBottom:2 }}>
              {FILTERS.map(f=>{ const active=filterSt===f; return <button key={f} onClick={()=>setFilterSt(f)} style={{ background:active?"linear-gradient(135deg," + OR + "," + ORD + ")":BG3, color:active?"#fff":MUTED, border:"1px solid " + (active?OR:BG4), borderRadius:20, padding:"6px 14px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:12, fontWeight:active?700:500, cursor:"pointer", whiteSpace:"nowrap", flexShrink:0, textTransform:"capitalize", transition:"all .15s" }}>{f==="all"?"All":f.charAt(0).toUpperCase()+f.slice(1)}</button>; })}
            </div>
          </div>
          <div style={{ padding:"0 16px 32px", display:"flex", flexDirection:"column", gap:11 }}>
            {filteredJobs.length===0&&<div style={{ textAlign:"center", color:DIM, padding:"48px 0", fontFamily:"'Bebas Neue',sans-serif", fontSize:18, letterSpacing:2 }}>NO JOBS FOUND</div>}
            {filteredJobs.map(job=>{
              const jobPics=photos.filter(p=>p.job_id===job.id);
              const thumb=jobPics[jobPics.length-1]?.image_url;
              const an=buildJobAnalytics(job,photos,staleThreshold,staleAlertsEnabled);
              const isStale=an.momentum==="stale"&&job.status==="active";
              const sc=STATUS_COLORS[job.status];
              const barCol=an.pctTime>=100?"#ef4444":an.pctTime>=80?OR:"#4ade80";
              return (
                <div key={job.id} onClick={()=>openJob(job)} style={{ background:BG2, border:"1px solid " + (isStale?"#ef444430":BG4), borderLeft:"3px solid " + (isStale?"#ef4444":sc.border), borderRadius:14, overflow:"hidden", cursor:"pointer", transition:"transform .15s, box-shadow .15s" }}
                  onMouseEnter={e=>{ e.currentTarget.style.transform="translateY(-2px)"; e.currentTarget.style.boxShadow="0 6px 28px #0007"; }}
                  onMouseLeave={e=>{ e.currentTarget.style.transform="translateY(0)"; e.currentTarget.style.boxShadow="none"; }}>
                  {thumb&&<div style={{ height:100, overflow:"hidden", position:"relative" }}><img src={thumb} alt="" style={{ width:"100%", height:"100%", objectFit:"cover" }} /><div style={{ position:"absolute", inset:0, background:"linear-gradient(to bottom, transparent 30%," + BG2 + ")" }} /><div style={{ position:"absolute", bottom:8, right:10, background:"#000a", color:OR, fontFamily:"'Bebas Neue',sans-serif", fontSize:12, letterSpacing:1, padding:"2px 9px", borderRadius:20, border:"1px solid var(--brand-or-25)" }}>{jobPics.length} PHOTO{jobPics.length!==1?"S":""}</div></div>}
                  <div style={{ padding:"14px 16px 15px" }}>
                    <div style={{ display:"flex", alignItems:"flex-start", justifyContent:"space-between", gap:8, marginBottom:5 }}>
                      <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:21, color:TEXT, letterSpacing:1, lineHeight:1.1 }}>{job.name}</div>
                      <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:3 }}>{isStale&&<span style={{ color:"#ef4444", fontSize:10, fontWeight:700, whiteSpace:"nowrap" }}>⚠️ {an.staleDays}d stale</span>}<span style={{ color:DIM, fontSize:18 }}>›</span></div>
                    </div>
                    {job.address&&<div style={{ color:DIM, fontSize:12, marginBottom:7 }}>📍 {job.address}</div>}
                    {job.description&&<p style={{ color:MUTED, fontSize:12, lineHeight:1.6, marginBottom:10 }}>{job.description}</p>}
                    {job.crew?.length>0&&<div style={{ display:"flex", alignItems:"center", gap:5, marginBottom:10 }}>{(job.crew||[]).slice(0,5).map(m=><Avatar key={m} name={m} size={24} />)}{job.crew.length>5&&<span style={{ color:DIM, fontSize:11 }}>+{job.crew.length-5}</span>}</div>}
                    {an.pctTime!==null&&job.status==="active"&&<div style={{ marginBottom:10 }}><div style={{ height:5, background:BG4, borderRadius:3, overflow:"hidden" }}><div style={{ height:"100%", width:Math.min(100,an.pctTime)+"%", background:barCol, borderRadius:3, transition:"width .5s" }} /></div><div style={{ color:DIM, fontSize:10, marginTop:3 }}>{an.elapsedDays}d of {job.estimated_days}d estimate ({an.pctTime}%)</div></div>}
                    <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between" }}>
                      <StatusBadge status={job.status} />
                      <div style={{ display:"flex", gap:6, alignItems:"center" }}>
                        {!thumb&&<span style={{ background:BG3, border:"1px solid " + BG4, color:MUTED, fontSize:11, padding:"3px 9px", borderRadius:20 }}>📸 {jobPics.length}</span>}
                        {isAdmin?<button onClick={e=>openEdit(job,e)} style={{ background:BG3, border:"1px solid " + BG4, color:MUTED, fontSize:11, borderRadius:7, padding:"4px 11px", cursor:"pointer" }}>Edit</button>:<span style={{ color:DIM, fontSize:11 }}>View only</span>}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ANALYTICS */}
      {view==="analytics"&&<div style={{ paddingBottom:80 }}><AnalyticsDashboard jobs={jobs} photos={photos} staleThreshold={staleThreshold} staleAlertsEnabled={staleAlertsEnabled} allCategories={allCategories} /></div>}

      {/* TEAM */}
      {view==="team"&&profile?.role==="owner"&&(
        <TeamScreen companyId={companyId} sessionUserId={session.user.id} />
      )}

      {/* SETTINGS */}
      {view==="settings"&&isAdmin&&(
        <BrandingSettings
          companyId={companyId}
          branding={branding}
          plan={billing?.plan}
          staleThreshold={staleThreshold}
          staleAlertsEnabled={staleAlertsEnabled}
          onBrandingUpdate={(b)=>{ setBranding(b); showToast("SETTINGS UPDATED ✓"); }}
          onGoToPlans={()=>setView("plans")}
          onStaleUpdate={(t,e)=>{ setStaleThreshold(t); setStaleAlertsEnabled(e); }}
          cancelAtPeriodEnd={cancelAtPeriodEnd}
          currentPeriodEnd={currentPeriodEnd}
          onCancelSubscription={profile?.role==="owner" ? handleCancelSubscription : undefined}
          onReactivateSubscription={profile?.role==="owner" ? handleReactivateSubscription : undefined}
          onOpenPortal={profile?.role==="owner" ? handleOpenPortal : undefined}
          customCategories={customCategories}
          onSaveCustomCategories={handleSaveCustomCategories}
        />
      )}

      {/* PLANS */}
      {view==="plans"&&(
        <div style={{ padding:"24px 16px 80px", animation:"fadeIn .25s ease" }}>
          <h2 style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:28, color:TEXT, letterSpacing:2, marginBottom:4 }}>CHOOSE A PLAN</h2>
          <div style={{ width:40, height:3, background:"linear-gradient(90deg," + ORD + "," + ORL + ")", borderRadius:2, marginBottom:8 }} />
          <p style={{ color:MUTED, fontSize:13, lineHeight:1.6, marginBottom:24, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>Upgrade now and keep building. Your photos and jobs are safe.</p>
          {checkoutError&&<div style={{ background:"#2a0a0a", border:"1px solid #ef444460", color:"#ef4444", fontSize:13, padding:"10px 14px", borderRadius:8, marginBottom:16 }}>{checkoutError}</div>}
          <div style={{ display:"flex", flexDirection:"column", gap:12, marginBottom:20 }}>
            {PLAN_CARDS.map(plan=>(
              <div key={plan.id} style={{ background:BG2, border:"2px solid " + (plan.popular?plan.color:BG4), borderRadius:16, padding:"20px", position:"relative" }}>
                {plan.popular&&<div style={{ position:"absolute", top:-12, left:"50%", transform:"translateX(-50%)", background:"#f97316", color:"#fff", fontFamily:"'Bebas Neue',sans-serif", fontSize:12, letterSpacing:2, padding:"3px 14px", borderRadius:20, whiteSpace:"nowrap" }}>MOST POPULAR</div>}
                <div style={{ display:"flex", alignItems:"flex-end", justifyContent:"space-between", marginBottom:14 }}>
                  <div>
                    <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:22, color:plan.color, letterSpacing:3 }}>{plan.name}</div>
                    <div style={{ display:"flex", alignItems:"baseline", gap:4 }}>
                      <span style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:36, color:TEXT }}>${plan.price}</span>
                      <span style={{ color:MUTED, fontSize:13 }}>/mo</span>
                    </div>
                  </div>
                  <button
                    onClick={()=>handleChoosePlan(plan.id)}
                    disabled={checkingOut!==null}
                    style={{ background:"linear-gradient(135deg," + plan.color + "," + (plan.id==="business"?"#d97706":plan.id==="pro"?"#c2410c":"#2563eb") + ")", color:"#fff", border:"none", borderRadius:10, padding:"10px 20px", fontFamily:"'Bebas Neue',sans-serif", fontSize:15, letterSpacing:2, cursor:checkingOut!==null?"not-allowed":"pointer", opacity:checkingOut!==null?0.7:1, whiteSpace:"nowrap" }}
                  >
                    {checkingOut===plan.id?"LOADING...":"CHOOSE PLAN"}
                  </button>
                </div>
                <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
                  {plan.features.map(f=>(
                    <div key={f} style={{ display:"flex", alignItems:"center", gap:8, color:MUTED, fontSize:12 }}>
                      <span style={{ color:plan.color, fontSize:12, flexShrink:0 }}>✓</span>{f}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <p style={{ color:DIM, fontSize:11, textAlign:"center", lineHeight:1.6 }}>Secure payment via Stripe. Cancel anytime. No hidden fees.</p>
        </div>
      )}

      {/* CHURN INSIGHTS — master admin only */}
      {view==="churn"&&process.env.REACT_APP_MASTER_ADMIN_EMAIL&&session.user.email===process.env.REACT_APP_MASTER_ADMIN_EMAIL&&(
        <ChurnScreen />
      )}

      {/* NEW / EDIT JOB */}
      {(view==="newjob"||view==="editjob")&&isAdmin&&(
        <div style={{ padding:"24px 16px", animation:"fadeIn .25s ease" }}>
          <h2 style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:28, color:TEXT, letterSpacing:2, marginBottom:4 }}>{view==="newjob"?"NEW JOB SITE":"EDIT JOB SITE"}</h2>
          <div style={{ width:40, height:3, background:"linear-gradient(90deg," + ORD + "," + ORL + ")", borderRadius:2, marginBottom:22 }} />
          {[["JOB NAME *","name","e.g. Smith Deck Build"],["ADDRESS","address","e.g. 142 Maple Ave"]].map(([label,field,ph])=>(
            <div key={field}><label style={{ color:MUTED, fontSize:11, letterSpacing:2, display:"block", marginBottom:5 }}>{label}</label><input value={form[field]||""} onChange={e=>setForm(f=>({...f,[field]:e.target.value}))} placeholder={ph} style={inp} /></div>
          ))}
          <label style={{ color:MUTED, fontSize:11, letterSpacing:2, display:"block", marginBottom:5 }}>DESCRIPTION</label>
          <textarea value={form.description||""} onChange={e=>setForm(f=>({...f,description:e.target.value}))} placeholder="Scope of work..." rows={3} style={{ ...inp, resize:"vertical", lineHeight:1.6 }} />
          <label style={{ color:MUTED, fontSize:11, letterSpacing:2, display:"block", marginBottom:5 }}>ESTIMATED DAYS TO COMPLETE</label>
          <input type="number" value={form.estimated_days||""} onChange={e=>setForm(f=>({...f,estimated_days:e.target.value}))} placeholder="e.g. 14" style={inp} />
          <label style={{ color:MUTED, fontSize:11, letterSpacing:2, display:"block", marginBottom:10 }}>STATUS</label>
          <div style={{ display:"flex", gap:8, marginBottom:28 }}>
            {["active","completed","on hold"].map(s=>{ const sel=form.status===s; const c=STATUS_COLORS[s]; return <button key={s} onClick={()=>setForm(f=>({...f,status:s}))} style={{ background:sel?c.bg:BG3, border:"1px solid " + (sel?c.border:BG4), color:sel?c.text:MUTED, borderRadius:20, padding:"7px 16px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:13, fontWeight:sel?700:400, cursor:"pointer", textTransform:"capitalize", transition:"all .15s" }}>{s}</button>; })}
          </div>
          <button onClick={saveJob} style={{ width:"100%", background:"linear-gradient(135deg," + OR + "," + ORD + ")", color:"#fff", border:"none", borderRadius:10, padding:"14px", fontFamily:"'Bebas Neue',sans-serif", fontSize:18, letterSpacing:2, cursor:"pointer", marginBottom:10, boxShadow:"0 4px 20px var(--brand-or-25)" }}>{view==="newjob"?"CREATE JOB":"SAVE CHANGES"}</button>
          {view==="editjob"&&<button onClick={()=>deleteJob(form.id)} style={{ width:"100%", background:"none", color:"#ef4444", border:"1px solid #3a1a1a", borderRadius:10, padding:"12px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:14, cursor:"pointer" }}>Delete This Job</button>}
        </div>
      )}

      {/* JOB DETAIL */}
      {view==="job"&&activeJob&&(
        <div style={{ animation:"fadeIn .25s ease" }}>
          <div style={{ padding:"16px 16px 14px", borderBottom:"1px solid " + BG4, borderLeft:"3px solid " + (STATUS_COLORS[activeJob.status]?.border||BG4), background:"linear-gradient(180deg,#1f2330," + BG + ")" }}>
            <div style={{ display:"flex", alignItems:"flex-start", justifyContent:"space-between", marginBottom:4 }}>
              <h1 style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:26, color:TEXT, letterSpacing:1.5, lineHeight:1 }}>{activeJob.name}</h1>
              <div style={{ display:"flex", gap:6, flexShrink:0 }}>
                {isAdmin&&<button onClick={()=>setShowCrew(true)} style={{ background:BG3, border:"1px solid " + BG4, color:MUTED, fontSize:12, borderRadius:7, padding:"5px 11px", cursor:"pointer" }}>👷 Crew</button>}
                {isAdmin&&<button onClick={()=>openEdit(activeJob)} style={{ background:BG3, border:"1px solid " + BG4, color:MUTED, fontSize:12, borderRadius:7, padding:"5px 11px", cursor:"pointer" }}>Edit</button>}
              </div>
            </div>
            {activeJob.address&&<div style={{ color:DIM, fontSize:12, marginBottom:4 }}>📍 {activeJob.address}</div>}
            {activeJob.description&&<p style={{ color:MUTED, fontSize:13, lineHeight:1.55, marginBottom:8 }}>{activeJob.description}</p>}
            {activeJob.crew?.length>0&&<div style={{ display:"flex", flexWrap:"wrap", gap:6, marginBottom:8 }}>{(activeJob.crew||[]).map(m=><div key={m} style={{ display:"flex", alignItems:"center", gap:5, background:BG3, border:"1px solid " + BG4, borderRadius:20, padding:"3px 10px 3px 5px" }}><Avatar name={m} size={20} /><span style={{ color:TEXT, fontSize:11, fontWeight:600 }}>{m}</span></div>)}</div>}
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between" }}>
              <StatusBadge status={activeJob.status} />
              <span style={{ color:DIM, fontSize:11 }}>Created {fmtD(activeJob.created_at)}</span>
            </div>
          </div>
          <div style={{ display:"flex", borderBottom:"1px solid " + BG4, background:BG2 }}>
            {[["photos","📸 Photos"],["analytics","📊 Analytics"]].map(([id,label])=>(
              <button key={id} onClick={()=>setJobTab(id)} style={{ flex:1, background:"none", border:"none", borderBottom:"2px solid " + (jobTab===id?OR:"transparent"), color:jobTab===id?OR:MUTED, padding:"12px 0", fontFamily:"'Bebas Neue',sans-serif", fontSize:14, letterSpacing:2, cursor:"pointer", transition:"color .15s" }}>{label}</button>
            ))}
          </div>
          <div style={{ padding:"16px 16px 40px" }}>
            {jobTab==="analytics"&&<JobAnalyticsPanel job={activeJob} photos={photos} staleThreshold={staleThreshold} staleAlertsEnabled={staleAlertsEnabled} allCategories={allCategories} />}
            {jobTab==="photos"&&(<>
              {!username&&<div style={{ background:"#2a1505", border:"1px solid var(--brand-or-25)", borderRadius:10, padding:"10px 14px", marginBottom:14, display:"flex", alignItems:"center", gap:8 }}><span>⚠️</span><span style={{ color:ORL, fontSize:13, fontWeight:600 }}>Set your name above before uploading.</span></div>}
              <div style={{ marginBottom:14 }}>
                <label style={{ color:MUTED, fontSize:11, letterSpacing:2, display:"block", marginBottom:7 }}>UPLOAD CATEGORY</label>
                <div style={{ display:"flex", gap:6, overflowX:"auto", paddingBottom:4 }}>
                  {allCategories.map(c=>{ const sel=uploadCat===c; const cc=CAT_COLOR[c]||"#94a3b8"; return <button key={c} onClick={()=>setUploadCat(c)} style={{ background:sel?cc+"22":BG3, border:"1px solid " + (sel?cc+"60":BG4), color:sel?cc:MUTED, borderRadius:20, padding:"5px 12px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:12, fontWeight:sel?700:500, cursor:"pointer", whiteSpace:"nowrap", flexShrink:0, transition:"all .15s" }}>{CAT_ICONS[c]||"📷"} {c}</button>; })}
                </div>
              </div>
              <DropZone onFiles={handleUpload} />
              {uploading&&<Spinner />}
              {!uploading&&(<>
                {usedCats.length>1&&<div style={{ display:"flex", gap:6, marginBottom:14, overflowX:"auto", paddingBottom:2 }}>{["All",...usedCats].map(c=>{ const sel=filterCat===c; const col=c==="All"?OR:(CAT_COLOR[c]||"#94a3b8"); return <button key={c} onClick={()=>setFilterCat(c)} style={{ background:sel?(c==="All"?"linear-gradient(135deg," + OR + "," + ORD + ")":col+"22"):BG3, border:"1px solid " + (sel?col+"80":BG4), color:sel?(c==="All"?"#fff":col):MUTED, borderRadius:20, padding:"5px 12px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:12, fontWeight:sel?700:500, cursor:"pointer", whiteSpace:"nowrap", flexShrink:0 }}>{c==="All"?"All":(CAT_ICONS[c]||"📷")+" "+c}</button>; })}</div>}
                <div style={{ marginBottom:12, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <span style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:13, color:DIM, letterSpacing:3 }}>{filteredPhotos.length} PHOTO{filteredPhotos.length!==1?"S":""}</span>
                  {!isAdmin&&filteredPhotos.length>0&&<span style={{ color:DIM, fontSize:11 }}>🔒 Admin can delete</span>}
                </div>
                {filteredPhotos.length===0&&<div style={{ textAlign:"center", color:DIM, padding:"32px 0", fontFamily:"'Bebas Neue',sans-serif", fontSize:16, letterSpacing:2 }}>NO PHOTOS YET — DROP SOME ABOVE</div>}
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
                  {[...filteredPhotos].reverse().map(photo=>(
                    <PhotoCard key={photo.id} photo={photo} isAdmin={isAdmin} allCategories={allCategories} onDelete={id=>deletePhoto(id)} onUpdate={(id,ch)=>updatePhoto(id,ch)} />
                  ))}
                </div>
              </>)}
            </>)}
          </div>
        </div>
      )}

      {showAdminModal&&<AdminModal adminPassword={adminPassword} onClose={()=>setShowAdminModal(false)} onSuccess={()=>{setIsAdmin(true);showToast("ADMIN MODE UNLOCKED 🔓");}} onChangePassword={saveAdminPw} />}
      {showCrew&&activeJob&&isAdmin&&<CrewModal job={activeJob} onClose={()=>setShowCrew(false)} onSave={saveCrew} />}
      {showInvite&&(
        <div onClick={()=>setShowInvite(false)} style={{ position:"fixed", inset:0, background:"#000d", zIndex:9100, display:"flex", alignItems:"flex-end", justifyContent:"center" }}>
          <div onClick={e=>e.stopPropagation()} style={{ background:BG2, border:"1px solid " + BG4, borderRadius:"18px 18px 0 0", width:"100%", maxWidth:480, padding:"28px 22px 40px", animation:"slideUp .25s ease" }}>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16 }}>
              <span style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:22, color:OR, letterSpacing:2 }}>INVITE CREW MEMBER</span>
              <button onClick={()=>setShowInvite(false)} style={{ background:"none", border:"none", color:MUTED, fontSize:20, cursor:"pointer" }}>✕</button>
            </div>
            <p style={{ color:MUTED, fontSize:13, lineHeight:1.6, marginBottom:20 }}>Share this link with your crew member. It expires in 7 days and can only be used once.</p>
            <div style={{ background:BG3, border:"1px solid " + BG4, borderRadius:10, padding:"12px 14px", marginBottom:16, wordBreak:"break-all", color:TEXT, fontSize:12, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
              {inviteLink}
            </div>
            <div style={{ display:"flex", gap:10 }}>
              <button onClick={()=>{ navigator.clipboard.writeText(inviteLink); showToast("LINK COPIED ✓"); setShowInvite(false); }} style={{ flex:1, background:"linear-gradient(135deg," + OR + "," + ORD + ")", color:"#fff", border:"none", borderRadius:10, padding:"14px", fontFamily:"'Bebas Neue',sans-serif", fontSize:16, letterSpacing:2, cursor:"pointer", boxShadow:"0 4px 20px var(--brand-or-25)" }}>📋 COPY LINK</button>
              <button onClick={()=>{ window.open("sms:?body=Join our crew on BeamShots! " + inviteLink); }} style={{ flex:1, background:BG3, color:TEXT, border:"1px solid " + BG4, borderRadius:10, padding:"14px", fontFamily:"'Bebas Neue',sans-serif", fontSize:16, letterSpacing:2, cursor:"pointer" }}>💬 TEXT IT</button>
            </div>
          </div>
        </div>
      )}
      {toast&&<Toast msg={toast} />}

      {/* ATHENA FLOATING BUTTON */}
      {branding.athenaEnabled !== false && (
        <AthenaButton
          onClick={()=>setShowAthena(true)}
          bottom={(view==="home"||view==="analytics"||view==="team") ? 84 : 24}
        />
      )}

      {/* ATHENA CHAT PANEL */}
      {showAthena && (
        <AthenaChat
          companyId={companyId}
          userId={session.user.id}
          plan={billing?.plan}
          onClose={()=>setShowAthena(false)}
        />
      )}
    </div>
  );
}
